webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);

var base = null;
if (false) {
    base = 'https://apipqrepm.emtelco.co/';
} else {
    base = 'https://apipqrepm.emtelco.co/';
}
/* harmony default export */ __webpack_exports__["a"] = ({
    api: base + 'api',
    year: '2019',
    email: base + 'email',
    change_password: base + 'change_password/',
    create_pqr: base + 'create_pqr/',
    download: base + 'download_attachment/',
    permissions: [],
    isLogin: false,
    hasPerm: function hasPerm(permission) {
        var permissions = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.getJSON('permissions');
        if (permissions.indexOf(permission) >= 0) {
            return true;
        }
        return false;
    },
    typePqrList: function typePqrList() {
        return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.getJSON('typePqrList');
    },
    statusPqrList: [{
        'value': 'CLOSED',
        'label': 'Cerrado'
    }, {
        'value': 'SCALED',
        'label': 'Escalado'
    }, {
        'value': 'PENDING',
        'label': 'Pendiente Verificación'
    }],
    statusList: [{
        'value': false,
        'label': 'Inactivo'
    }, {
        'value': true,
        'label': 'Activo'
    }]
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emt_login__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emt_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_emt_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_emt_home__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_emt_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_emt_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form_user__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_form_edit_user__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_form_edit_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_form_edit_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_form_unit__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_form_unit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_form_unit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_emt_form_edit_unit__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_emt_form_edit_unit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_emt_form_edit_unit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_emt_form_area__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_emt_form_area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_emt_form_area__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_emt_form_edit_area__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_emt_form_edit_area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_emt_form_edit_area__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_emt_form_reason__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_emt_form_reason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_emt_form_reason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_emt_form_edit_reason__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_emt_form_edit_reason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_emt_form_edit_reason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_emt_form_subreason__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_emt_form_subreason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_emt_form_subreason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_emt_form_edit_subreason__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_emt_form_edit_subreason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_emt_form_edit_subreason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_emt_form_company__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_emt_form_company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_emt_form_company__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_emt_form_edit_company__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_emt_form_edit_company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_emt_form_edit_company__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_emt_form_channel__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_emt_form_channel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_emt_form_channel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_emt_form_edit_channel__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_emt_form_edit_channel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_emt_form_edit_channel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_emt_form_date_not_available__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_emt_form_date_not_available___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_emt_form_date_not_available__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_emt_form_consult_pqr__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_emt_form_consult_pqr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_emt_form_consult_pqr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_emt_form_register_pqr__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_emt_form_register_pqr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_emt_form_register_pqr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_emt_form_update_pqr__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_emt_form_update_pqr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_emt_form_update_pqr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_emt_reassignment__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_emt_reassignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_emt_reassignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_emt_change_password__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_emt_change_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_emt_change_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_emt_form_export__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_emt_form_export___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_emt_form_export__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_emt_form_gender__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_emt_form_gender___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_emt_form_gender__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_emt_form_edit_gender__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_emt_form_edit_gender___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_emt_form_edit_gender__);




























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_emt_login___default.a,
        alias: '/login'
    }, {
        path: '/home',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_3__components_emt_home___default.a
    }, {
        path: '/User',
        name: 'User',
        component: __WEBPACK_IMPORTED_MODULE_4__components_emt_form_user___default.a
    }, {
        path: '/User/:id',
        name: 'EditUser',
        component: __WEBPACK_IMPORTED_MODULE_5__components_emt_form_edit_user___default.a,
        props: true
    }, {
        path: '/Unit',
        name: 'Unit',
        component: __WEBPACK_IMPORTED_MODULE_6__components_emt_form_unit___default.a
    }, {
        path: '/Unit/:id',
        name: 'EditUnit',
        component: __WEBPACK_IMPORTED_MODULE_7__components_emt_form_edit_unit___default.a,
        props: true
    }, {
        path: '/Area',
        name: 'Area',
        component: __WEBPACK_IMPORTED_MODULE_8__components_emt_form_area___default.a
    }, {
        path: '/Area/:id',
        name: 'EditArea',
        component: __WEBPACK_IMPORTED_MODULE_9__components_emt_form_edit_area___default.a,
        props: true
    }, {
        path: '/Reason',
        name: 'Reason',
        component: __WEBPACK_IMPORTED_MODULE_10__components_emt_form_reason___default.a
    }, {
        path: '/EditReason/:id',
        name: 'EditReason',
        component: __WEBPACK_IMPORTED_MODULE_11__components_emt_form_edit_reason___default.a,
        props: true
    }, {
        path: '/Subreason',
        name: 'Subreason',
        component: __WEBPACK_IMPORTED_MODULE_12__components_emt_form_subreason___default.a
    }, {
        path: '/Subreason/:id',
        name: 'EditSubreason',
        component: __WEBPACK_IMPORTED_MODULE_13__components_emt_form_edit_subreason___default.a,
        props: true
    }, {
        path: '/Channel',
        name: 'Channel',
        component: __WEBPACK_IMPORTED_MODULE_16__components_emt_form_channel___default.a
    }, {
        path: '/Channel/:id',
        name: 'EditChannel',
        component: __WEBPACK_IMPORTED_MODULE_17__components_emt_form_edit_channel___default.a,
        props: true
    }, {
        path: '/Company',
        name: 'Company',
        component: __WEBPACK_IMPORTED_MODULE_14__components_emt_form_company___default.a
    }, {
        path: '/Company/:id',
        name: 'EditCompany',
        component: __WEBPACK_IMPORTED_MODULE_15__components_emt_form_edit_company___default.a,
        props: true
    }, {
        path: '/DateNotAvailable',
        name: 'DateNotAvailable',
        component: __WEBPACK_IMPORTED_MODULE_18__components_emt_form_date_not_available___default.a
    }, {
        path: '/ConsultPqr',
        name: 'ConsultPqr',
        component: __WEBPACK_IMPORTED_MODULE_19__components_emt_form_consult_pqr___default.a
    }, {
        path: '/RegisterPqr',
        name: 'RegisterPqr',
        component: __WEBPACK_IMPORTED_MODULE_20__components_emt_form_register_pqr___default.a
    }, {
        path: '/UpdatePqr/:id',
        name: 'UpdatePqr',
        component: __WEBPACK_IMPORTED_MODULE_21__components_emt_form_update_pqr___default.a,
        props: true
    }, {
        path: '/Reassignment/:id',
        name: 'Reassignment',
        component: __WEBPACK_IMPORTED_MODULE_22__components_emt_reassignment___default.a,
        props: true
    }, {
        path: '/ChangePassword/:id',
        name: 'ChangePassword',
        component: __WEBPACK_IMPORTED_MODULE_23__components_emt_change_password___default.a,
        props: true
    }, {
        path: '/Export/',
        name: 'Exports',
        component: __WEBPACK_IMPORTED_MODULE_24__components_emt_form_export___default.a,
        props: true
    }, {
        path: '/Genero',
        name: 'Gender',
        component: __WEBPACK_IMPORTED_MODULE_25__components_emt_form_gender___default.a
    }, {
        path: '/Genero/:id',
        name: 'EditGender',
        component: __WEBPACK_IMPORTED_MODULE_26__components_emt_form_edit_gender___default.a,
        props: true
    }]
}));

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["a"] = ({
    setToken: function setToken() {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Authorization'] = 'JWT ' + __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token');
    }
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(138),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arrays; });

var Arrays = {};

function getItemBy(items, field, value) {
    var itemsL = items.length;
    if (itemsL > 0) {
        if (typeof items[0][field] !== 'undefined') {
            for (var index = 0; index < items.length; index++) {
                if (items[index][field] === value) {
                    return items[index];
                }
            }
        }
    }
    return undefined;
}

function clearSelect(arrayItem, item, callbackObject) {
    for (var i = 0; i < item.dependencies.length; i++) {
        for (var j = 0; j < arrayItem.length; j++) {
            if (arrayItem[j].name === item.dependencies[i]) {
                arrayItem[j].select_options = [];
            }
        }
    }
    if (typeof callbackObject !== 'undefined') {
        for (var k = 0; k < callbackObject.functions.length; k++) {
            if (item.value !== '') {
                callbackObject.functions[k](callbackObject.arguments[k]);
            }
        }
    }
}

function range(param1, param2, param3) {
    var start = 0;
    var end = 0;
    var b = 1;
    var items = [];
    if (typeof param2 === 'undefined') {
        end = param1;
    } else {
        start = param1;
        end = param2;
    }
    if (typeof param3 !== 'undefined' && param3 > 0) {
        b = param3;
    }
    for (var index = start; index <= end; index = index + b) {
        items.push(index);
    }
    return items;
}

Arrays.getItemBy = getItemBy;
Arrays.clearSelect = clearSelect;
Arrays.range = range;



/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(193),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(3);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_emt_header__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_emt_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_emt_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_emt_menu_bar__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_emt_menu_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_emt_menu_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emt_footer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emt_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_emt_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            login: false
        };
    },
    components: {
        'emt-header': __WEBPACK_IMPORTED_MODULE_0__components_emt_header___default.a,
        'emt-menu-bar': __WEBPACK_IMPORTED_MODULE_1__components_emt_menu_bar___default.a,
        'emt-footer': __WEBPACK_IMPORTED_MODULE_2__components_emt_footer___default.a
    },
    methods: {
        showMenuBar: function showMenuBar() {
            this.login = true;
        },
        hideMenuBar: function hideMenuBar() {
            this.login = false;
        }
    },
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('token')) {
            this.login = true;
        }
    }
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(74),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-header'
});

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "img-responsive logo-header",
    attrs: {
      "src": "static/img/Logo-EPM2.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive logo-header",
    attrs: {
      "src": "static/img/Logo-Emtelco2.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive pull-right logo-header",
    attrs: {
      "src": "static/img/Logo2.png"
    }
  })])
}]}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(77),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-menu-bar',
    data: function data() {
        return {
            data: {
                adminDisplay: '',
                pqrDisplay: '',
                collapsed: true
            },
            Cookies: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a,
            config: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */],
            user: '',
            date: ''
        };
    },
    methods: {
        toggleCollapse: function toggleCollapse(e) {
            var self = this;
            e && e.preventDefault();
            self.data.collapsed = !self.data.collapsed;
        },
        toggleOptionsAdmin: function toggleOptionsAdmin() {
            var self = this;
            if (self.data.adminDisplay === '') {
                self.data.adminDisplay = 'open';
            } else {
                self.data.adminDisplay = '';
            }

            if (self.data.adminDisplay === 'open') {
                self.data.pqrDisplay = '';
            }
        },
        toggleOptionsPQR: function toggleOptionsPQR() {
            var self = this;
            if (self.data.pqrDisplay === '') {
                self.data.pqrDisplay = 'open';
            } else {
                self.data.pqrDisplay = '';
            }

            if (self.data.pqrDisplay === 'open') {
                self.data.adminDisplay = '';
            }
        },
        hideOptions: function hideOptions() {
            var self = this;
            self.data.adminDisplay = '';
            self.data.pqrDisplay = '';
        },
        logout: function logout() {
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('token');
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('idUser');
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('permissions');
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('username');
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('perfil');
            __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].isLogin = false;
            this.$parent.hideMenuBar();
        },
        listener: function listener(e) {
            var self = this;
            if (e.target.toString() !== 'javascript:void(0);') {
                self.hideOptions();
            }
        }
    },
    created: function created() {
        this.user = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('username');
        this.date = new Date().toLocaleString();
        var self = this;
        setInterval(function () {
            self.date = new Date().toLocaleString();
        }, 1000);
    },
    mounted: function mounted() {
        var self = this;
        window.addEventListener('click', self.listener);
    },
    destroyed: function destroyed() {
        var self = this;
        window.removeEventListener('click', self.listener);
    }
});

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])]), _vm._v(" "), _c('div', {
    class: ['navbar-collapse', {
      collapse: _vm.data.collapsed
    }],
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.config.hasPerm('add_channel') || _vm.config.hasPerm('add_area') || _vm.config.hasPerm('add_company') || _vm.config.hasPerm('add_datenotavailable') || _vm.config.hasPerm('add_user') || _vm.config.hasPerm('add_reason') || _vm.config.hasPerm('add_subreason') || _vm.config.hasPerm('add_unit')) ? _c('li', {
    staticClass: "dropdown",
    class: _vm.data.adminDisplay
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        _vm.toggleOptionsAdmin()
      }
    }
  }, [_vm._v("Administración "), _c('span', {
    staticClass: "caret",
    attrs: {
      "id": "menu-admin"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/User"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Usuarios")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Unit"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Unidades")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Area"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Áreas")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Reason"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Motivos")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Subreason"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Sub motivos")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Channel"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Canales")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Company"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Empresa o filial")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/DateNotAvailable"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Días no hábiles")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Export"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Exporte")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Genero"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Géneros")])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown",
    class: _vm.data.pqrDisplay
  }, [_c('a', {
    staticClass: "dropdown-toggle active",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        _vm.toggleOptionsPQR()
      }
    }
  }, [_vm._v("PQR "), _c('span', {
    staticClass: "caret",
    attrs: {
      "id": "menu-pqr"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.config.hasPerm('add_pqr')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/RegisterPqr"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Registrar")])], 1) : _vm._e(), _vm._v(" "), (_vm.config.hasPerm('can_list_pqr') && _vm.config.hasPerm('can_retrieve_pqr') && _vm.config.hasPerm('change_pqr')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/ConsultPqr"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Consultar")])], 1) : (_vm.config.hasPerm('can_list_pqr')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/ConsultPqr"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Consultar")])], 1) : _vm._e()])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('p', {
    staticClass: "date_bar"
  }, [_vm._v("Bienvenido: " + _vm._s(this.user) + " Fecha: " + _vm._s(this.date) + " ")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-footer',
    data: function data() {
        return {
            data: {
                year: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].year
            }
        };
    }
});

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._v("\n    Copyright © " + _vm._s(_vm.data.year) + " Medellín - Colombia Gerencia de Ingeniería y Desarrollo Emtelco S.A.S\n")])
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('emt-header'), _vm._v(" "), (_vm.login) ? _c('emt-menu-bar') : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1), _vm._v(" "), _c('emt-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-login',
    data: function data() {
        return {
            data: {
                username: null,
                password: null
            },
            errors: {
                username: [],
                password: [],
                detail: []
            }
        };
    },
    methods: {
        login: function login() {
            var self = this;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/login/login/', self.data).then(function (response) {
                self.loading = false;
                __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].isLogin = true;
                __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].permissions = response.body.permissions;
                __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('token', response.body.token);
                __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('idUser', response.body.id);
                __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('permissions', response.body.permissions);
                __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('username', response.body.username);
                __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('perfil', response.body.groups && response.body.groups[0]);
                __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Authorization'] = 'JWT ' + __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token');
                this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr_type/').then(function (response) {
                    var typePqrList = [];
                    for (var i = 0; i < response.body.results.length; i = i + 1) {
                        typePqrList.push({ 'value': response.body.results[i].id, 'label': response.body.results[i].name });
                    }
                    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('typePqrList', typePqrList);
                    this.$parent.showMenuBar();
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/home');
                }, function (response) {
                    self.errors = response.body;
                });
            }, function (response) {
                self.errors = response.body;
            });
        },
        listener: function listener(e) {
            var self = this;
            var containSwal = document.body.classList.contains('swal2-shown');
            if (e.key === 'Enter' && !containSwal) {
                self.login();
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        window.addEventListener('keyup', self.listener);
    },
    destroyed: function destroyed() {
        var self = this;
        window.removeEventListener('keyup', self.listener);
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('token');
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('idUser');
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('permissions');
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('typePqrList');
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('username');
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('perfil');
        localStorage.removeItem('filter');
    }
});

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "id": "background-login",
      "src": "/static/img/fondo.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post",
      "action": "",
      "id": "login",
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.username),
      expression: "data.username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Ingresar nombre de usuario",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.data.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.username), function(error) {
    return _c('div', {
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n                " + _vm._s(error) + "\n            ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.password),
      expression: "data.password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Ingresar contraseña",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.data.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.password), function(error) {
    return _c('div', {
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n                " + _vm._s(error) + "\n            ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.detail), function(error) {
    return _c('div', {
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n            " + _vm._s(error) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn-login"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btningresar",
      "name": "btningresar"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Ingresar")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container login text-center"
  }, [_c('h1', [_vm._v("Bienvenido")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "text"
    }
  }, [_vm._v("Ingresa tus datos")])])
}]}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(88),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-home'
});

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content-cards"
    }
  }, [_c('div', {
    staticClass: "txt-index"
  }, [_c('div', {
    staticClass: "cards"
  }, [_c('h2', [_vm._v("¡Bienvenidos!")]), _vm._v(" "), _c('p', [_vm._v("Por medio de esta página usted podrá interponer o gestionar peticiones, quejas, reclamos, felicitaciones o sugerencias, gracias por utilizar nuestros servicios.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img-index"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home.png"
    }
  })])])
}]}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(139),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-user',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'username',
                'label': 'Usuario',
                'placeholder': 'Ingrese nombre de usuario',
                'value': null,
                'maxlength': '30',
                'type': 'text',
                'errors': []
            }, {
                'name': 'password',
                'label': 'Contraseña',
                'placeholder': 'Ingrese contraseña',
                'value': null,
                'maxlength': '128',
                'type': 'password',
                'errors': []
            }, {
                'name': 'first_name',
                'label': 'Nombres',
                'value': null,
                'placeholder': 'Ingrese nombres',
                'maxlength': '30',
                'type': 'text',
                'errors': []
            }, {
                'name': 'last_name',
                'label': 'Apellidos',
                'value': null,
                'placeholder': 'Ingrese apellidos',
                'maxlength': '30',
                'type': 'text',
                'errors': []
            }, {
                'name': 'email',
                'label': 'Correo electrónico principal',
                'value': null,
                'placeholder': 'Ingrese correo electrónico principal',
                'maxlength': '254',
                'type': 'text',
                'errors': []
            }, {
                'name': 'email_alternative',
                'label': 'Correo electrónico alternativo',
                'value': null,
                'placeholder': 'Ingrese correo electrónico alternativo',
                'maxlength': '200',
                'type': 'text',
                'errors': []
            }, {
                'name': 'group',
                'label': 'Perfil',
                'placeholder': 'Seleccione un perfil',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'unit',
                'label': 'Unidad',
                'placeholder': 'Seleccione una unidad',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'visible': false
            }, {
                'name': 'company',
                'label': 'Empresa o filial',
                'placeholder': 'Seleccione una empresa o filial',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'visible': false
            }],
            itemsGrid: [{
                'name': 'username',
                'label': 'Usuario',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'first_name',
                'label': 'Nombres',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'last_name',
                'label': 'Apellidos',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'email',
                'label': 'Correo electrónico',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'groups',
                    'key': 'name'
                },
                'label': 'Perfil',
                'ordering': true
            }, {
                'name': 'is_active',
                'label': 'Activo',
                'ordering': true,
                'filters': ['exact'],
                'filterList': __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].statusList
            }],
            itemresource: [{
                'resourceUser': '/user/',
                'resourcePerfil': '/group/'
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/User/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/user/'
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['user-grid'].reload();
        },
        getUnits: function getUnits() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[7].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },
        getGroup: function getGroup() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/group/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[6].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },
        getCompany: function getCompany() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/company/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[8].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getGroup();
        this.getUnits();
        this.getCompany();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_input_components_emt_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_input_components_emt_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_input_components_emt_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_checkbox__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_radio__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_select__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_input_components_emt_textarea__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_input_components_emt_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_input_components_emt_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers__ = __webpack_require__(19);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-register-user',
    data: function data() {
        return {
            data: {
                form_values: {},
                form_perfil: {},
                errors: []
            },
            isLoading: false
        };
    },
    props: {
        resource: Array,
        items: Array,
        updateData: Boolean,
        typeactivity: String
    },
    methods: {
        getFormValuesPassword: function getFormValuesPassword() {
            var self = this;
            self.data.form_values = {};
            for (var i = 0; i < self.items.length; i++) {
                var value = null;
                if (typeof self.items[i].value === 'string') {
                    value = self.items[i].value != null ? self.items[i].value.trim() : null;
                } else {
                    value = self.items[i].value;
                }
                self.data.form_values[self.items[i].name] = value;
            }
            return self.data.form_values;
        },
        getFormValues: function getFormValues() {
            var idgroup = document.getElementsByName('group')[0].value;
            var self = this;
            self.data.form_values = {};
            for (var i = 0; i < self.items.length; i++) {
                var value = null;
                if (self.items[i].name === 'group') {
                    self.items[i].value = idgroup;
                }
                if (typeof self.items[i].value === 'string') {
                    value = self.items[i].value != null ? self.items[i].value.trim() : null;
                } else {
                    value = self.items[i].value;
                }
                self.data.form_values[self.items[i].name] = value;
            }
            return self.data.form_values;
        },

        clearFormValues: function clearFormValues() {
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].type === 'checkbox' || this.items[i].type === 'radio') {
                    this.items[i].value = false;
                } else if (this.items[i].type === 'select') {
                    this.items[i].selectoptions = 0;
                    this.items[i].value = '';
                } else {
                    this.items[i].value = null;
                }
            }
            for (i in this.items) {
                this.items[i].errors = [];
            }
            return null;
        },

        register: function register(table) {
            var self = this;
            var values = self.getFormValues();
            self.isLoading = true;
            self.$http.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api + self.resource[0].resourceUser, values).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a({
                    title: 'Se creó el registro exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                self.isLoading = false;
                self.clearFormValues();
                self.$emit('register');
            }, function (response) {
                self.data.errors = response.body;
                self.isLoading = false;
                var prop = null;
                for (var i in self.items) {
                    self.items[i].errors = [];
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            if (prop === 'unit' || prop === 'group') {
                                self.items[i].errors.push(response.body[prop]);
                            } else {
                                self.items[i].errors = response.body[prop];
                            }
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
        },
        updateDate: function updateDate(value) {
            for (var item in this.items) {
                value = value.toISOString().substring(0, 10);
                this.items[item].value = value;
            }
        },
        update: function update() {
            var self = this;
            var values = self.getFormValues();
            self.isLoading = true;
            self.$http.put(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api + self.resource[0].resourceUser + this.$route.params.id + '/', values).then(function (response) {
                self.isLoading = false;
                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a({
                    title: 'Se realizó la actualización exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                self.clearFormValues();
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].go(-1);
            }, function (response) {
                self.data.errors = response.body;
                self.isLoading = false;
                var prop = null;
                for (var i in self.items) {
                    self.items[i].errors = [];
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            self.items[i].errors.push(self.data.errors[prop]);
                        }
                    }
                }
            });
        },
        updatePassword: function updatePassword() {
            var self = this;
            var values = self.getFormValuesPassword();
            values['id'] = this.$route.params.id;
            self.isLoading = true;
            self.$http.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].change_password, values).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a({
                    title: 'Se realizó el cambio de contraseña exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/User');
                self.isLoading = false;
            }, function (response) {
                self.data.errors = response.body;
                self.isLoading = false;
                var prop = null;
                for (var i in self.items) {
                    self.items[i].errors = [];
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            self.items[i].errors = response.body[prop];
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
        },
        behind: function behind() {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].go(-1);
        },
        check: function check(item) {
            if (item.name === 'group') {
                var self = this;
                var text = __WEBPACK_IMPORTED_MODULE_9__helpers__["a" /* Arrays */].getItemBy(item.select_options, 'value', parseInt(item.value)).text;
                if (text === 'Consulta filial') {
                    __WEBPACK_IMPORTED_MODULE_9__helpers__["a" /* Arrays */].getItemBy(self.items, 'name', 'company').visible = true;
                    __WEBPACK_IMPORTED_MODULE_9__helpers__["a" /* Arrays */].getItemBy(self.items, 'name', 'unit').visible = false;
                } else {
                    __WEBPACK_IMPORTED_MODULE_9__helpers__["a" /* Arrays */].getItemBy(self.items, 'name', 'company').visible = false;
                    __WEBPACK_IMPORTED_MODULE_9__helpers__["a" /* Arrays */].getItemBy(self.items, 'name', 'unit').visible = true;
                }
            }
        }
    },
    components: {
        'emt-input': __WEBPACK_IMPORTED_MODULE_3__components_input_components_emt_input___default.a,
        'emt-checkbox': __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_checkbox___default.a,
        'emt-radio': __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_radio___default.a,
        'emt-select': __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_select___default.a,
        'emt-textarea': __WEBPACK_IMPORTED_MODULE_7__components_input_components_emt_textarea___default.a,
        'datepicker': __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-input',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function update(event) {
            var self = this;
            self.item.value = event.target.value;
            this.$emit('input', event.target.value);
        }
    }
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control margin-bottom",
    attrs: {
      "type": _vm.item.type,
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "maxlength": _vm.item.maxlength,
      "readonly": _vm.item.readonly,
      "max": _vm.item.max,
      "min": _vm.item.min
    },
    domProps: {
      "value": _vm.item.value
    },
    on: {
      "input": _vm.update
    }
  }), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-checkbox',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function update(event) {
            var self = this;
            self.$emit('email', event.target.value);
        }
    }
});

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.value),
      expression: "item.value"
    }],
    staticClass: "form-control margin-bottom",
    attrs: {
      "type": "checkbox",
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "disabled": _vm.item.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.item.value) ? _vm._i(_vm.item.value, null) > -1 : (_vm.item.value)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.item.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.item.value = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.item.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.item, "value", $$c)
        }
      }, _vm.update]
    }
  }), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-radio',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function update(event) {
            var self = this;
            self.item.value = event.target.value;
        }
    }
});

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control margin-bottom",
    attrs: {
      "type": "radio",
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "maxlength": _vm.item.maxlength
    },
    domProps: {
      "value": _vm.item.value
    },
    on: {
      "input": _vm.update
    }
  }), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-select',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function update(event) {
            var self = this;
            self.item.value = event.target.value;
            self.$emit('change');
        }
    }
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('select', {
    staticClass: "form-control margin-bottom",
    attrs: {
      "name": _vm.item.name,
      "disabled": _vm.item.disabled
    },
    on: {
      "input": _vm.update
    }
  }, [(_vm.item.value !== '') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.item.placeholder))]) : _c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.item.placeholder))]), _vm._v(" "), _vm._l((_vm.item.select_options), function(option) {
    return (_vm.item.value !== option.value) ? _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))]) : _c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  })], 2), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-textarea',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function update(event) {
            var self = this;
            self.item.value = event.target.value;
        }
    }
});

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control margin-bottom",
    attrs: {
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "maxlength": _vm.item.maxlength,
      "cols": _vm.item.cols,
      "rows": _vm.item.rows,
      "readonly": _vm.item.readonly
    },
    domProps: {
      "value": _vm.item.value
    },
    on: {
      "input": _vm.update
    }
  }), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post",
      "action": "",
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.items), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (typeof(item.visible) === 'undefined' || item.visible),
        expression: "typeof(item.visible)==='undefined' || item.visible"
      }]
    }, [(item.type === 'text' || item.type === 'number' || item.type === 'password' || item.type === 'file') ? _c('emt-input', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('emt-radio', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('emt-select', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      },
      on: {
        "change": function($event) {
          _vm.check(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'checkbox') ? _c('emt-checkbox', {
      attrs: {
        "item": item,
        "className": 'col-md-1'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'textarea') ? _c('emt-textarea', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "yyyy-MM-dd"
      },
      on: {
        "input": _vm.updateDate
      }
    }) : _vm._e(), _vm._v(" "), ((key + 1) % 3 === 0) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.updateData) ? _c('div', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('router-link', {
    attrs: {
      "to": '/ChangePassword/' + this.$route.params.id
    }
  }, [_vm._v("Restablecer contraseña")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [(_vm.updateData) ? _c('div', [_c('input', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "value": "Atrás",
      "name": "Atrás"
    },
    on: {
      "click": _vm.behind
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Actualizar",
      "name": "Actualizar"
    },
    on: {
      "click": _vm.update
    }
  }) : _c('span', [_vm._v("Cargando...")])]) : (_vm.typeactivity) ? _c('div', [_c('input', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "value": "Atrás",
      "name": "Atrás"
    },
    on: {
      "click": _vm.behind
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Cambiar contraseña",
      "name": "Cambiar contraseña"
    },
    on: {
      "click": _vm.updatePassword
    }
  }) : _c('span', [_vm._v("Cargando...")])]) : _c('div', [(!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Guardar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.register
    }
  }) : _c('span', [_vm._v("Cargando...")])])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        message: {
            type: String,
            default: 'Cargando...'
        }
    }
});

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
  }), _vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-grid',
    data: function data() {
        return {
            filterTypes: {
                exact: 'Exacto',
                contains: 'Contiene',
                icontains: 'Contiene',
                range: 'Rango'
            },
            filter: {},
            ordering: '',
            isLoading: false,
            loadingError: false,
            data: [],
            searchDisplay: false,
            pagination: {
                currentPage: null,
                numPages: null,
                count: null,
                previous: null,
                next: null
            },
            sourceFilter: null
        };
    },
    props: {
        resource: String,
        edit: String,
        deleteUrl: String,
        items: Array,
        btnEdit: {
            type: Boolean,
            default: true
        },
        btnDelete: {
            type: Boolean,
            default: true
        },
        btnDetail: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: ''
        },
        previousButtonText: {
            type: String,
            default: 'Anterior'
        },
        nextButtonText: {
            type: String,
            default: 'Siguiente'
        },
        paginationPlace: {
            type: String,
            default: 'BOTTOM',
            validator: function validator(value) {
                if (value !== 'TOP' && value !== 'BOTTOM' && value !== 'BOTH') {
                    return false;
                }
                return true;
            }
        },
        source: String
    },
    methods: {
        getTypeof: function getTypeof(value) {
            if (value === 'created_at') {
                return 'date';
            }
            return typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default.a(value);
        },

        parseUrl: function parseUrl(url) {
            var parser = document.createElement('a');
            parser.href = url;

            if (this.getTypeof(this.ordering) === 'object') {
                this.ordering = this.ordering.object;
            }
            if (parser.search === '' || parser.search === null) {
                url += '?ordering=' + this.ordering + '&';
            } else {
                url += '&ordering=' + this.ordering + '&';
            }

            if (localStorage.getItem('filter') && this.sourceFilter === 'consult') {
                var changeFilter = false;
                for (var i in this.filter) {
                    if (this.filter[i].value !== null) {
                        changeFilter = true;
                        break;
                    }
                }
                if (!changeFilter) {
                    this.filter = JSON.parse(localStorage.getItem('filter'));
                }
            }
            for (var filter in this.filter) {
                if (this.filter[filter].value === null) continue;
                if (this.filter[filter].name === 'exact') {
                    if (filter === 'reason' || filter === 'subreason' || filter === 'channel' || filter === 'unit' || filter === 'area' || filter === 'user_assigned' || filter === 'company' || filter === 'company') {
                        url += filter + '__name' + '=' + this.filter[filter].value + '&';
                    } else if (filter === 'status_display') {
                        url += 'status' + '=' + this.filter[filter].value + '&';
                    } else {
                        url += filter + '=' + this.filter[filter].value + '&';
                    }
                } else {
                    if (filter === 'reason' || filter === 'subreason' || filter === 'channel' || filter === 'unit' || filter === 'area' || filter === 'user_assigned' || filter === 'company') {
                        url += filter + '__name' + '__' + this.filter[filter].name + '=' + this.filter[filter].value + '&';
                    } else if (filter === 'account') {
                        url += filter + '__document' + '=' + this.filter[filter].value + '&';
                    } else {
                        url += filter + '__' + this.filter[filter].name + '=' + this.filter[filter].value + '&';
                    }
                }
            }
            if (this.sourceFilter === 'consult') {
                localStorage.setItem('filter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a(this.filter));
            }
            return url;
        },

        setOrdering: function setOrdering(value) {
            if (this.getTypeof(value) === 'object') {
                value = value.object;
            }
            if (value === 'status_display') {
                value = 'status';
            }
            if (value === this.ordering) {
                this.ordering = '-' + value;
            } else {
                if ('-' + value === this.ordering) {
                    this.ordering = '';
                } else {
                    this.ordering = value;
                }
            }
            this.getData(this.resource);
        },

        setPagination: function setPagination(pagination) {
            this.setData(pagination.results);
            this.pagination.currentPage = pagination['current_page'];
            this.pagination.numPages = pagination['num_pages'];
            this.pagination.count = pagination['count'];
            this.pagination.previous = pagination['previous'];
            this.pagination.next = pagination['next'];
        },

        setData: function setData(data) {
            this.data = data;
        },

        getData: function getData(url) {
            url = this.parseUrl(url);
            var self = this;
            self.isLoading = true;
            self.$http.get(url).then(function (response) {
                self.setPagination(response.body);
                self.isLoading = false;
                self.loadingError = false;
                if (self.searchDisplay) {
                    self.searchDisplay = !self.searchDisplay;
                }
            }, function (response) {
                self.loadingError = true;
                self.isLoading = false;
            });
        },
        getFilter: function getFilter(filter, type) {
            switch (typeof filter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default.a(filter)) {
                case 'string':
                    if (type === 'name') return filter;
                    if (type === 'label') return this.filterTypes[filter];
                    break;
                case 'object':
                    if (type === 'name') {
                        return filter.name;
                    }
                    if (type === 'label') {
                        if (typeof filter.label === 'undefined') {
                            return this.filterTypes[filter.name];
                        }
                        return filter.label;
                    }
                    break;
            }
        },
        reload: function reload() {
            this.getData(this.resource);
        },
        removeRegister: function removeRegister(id) {
            var url = this.deleteUrl + id + '/';
            var self = this;
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a({
                title: '¿Desea eliminar este registro?',
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí',
                cancelButtonText: 'No'
            }).then(function () {
                self.$http.delete(url).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a({
                        title: 'Se eliminó el registro exitosamente',
                        text: '',
                        type: 'success',
                        confirmButtonText: 'Aceptar'
                    });
                    this.getData(this.resource);
                }, function (response) {
                    __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: 'No se pudo eliminar el registro.',
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                });
            });
        }
    },
    watch: {
        resource: function resource(url) {
            this.getData(url);
        }
    },
    created: function created() {
        for (var item in this.items) {
            for (var filter in this.items[item].filters) {
                this.items[item].filterName = typeof this.items[item].filterName === 'undefined' ? this.items[item].name : this.items[item].filterName;
                this.items[item].filterName = this.items[item].filterName.object || this.items[item].filterName;
                var defaultFilterName = this.items[item].filters[filter].name || this.items[item].filters[filter];
                this.filter[this.items[item].filterName] = {
                    name: defaultFilterName,
                    value: null
                };
                break;
            }
        }
        this.sourceFilter = this.source;
        this.getData(this.resource);
    },
    components: {
        'emt-loading': __WEBPACK_IMPORTED_MODULE_2__components_emt_loading___default.a
    },
    mounted: function mounted() {
        this.getData(this.resource);
    }
});

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._t("header"), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search_form"
    }
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading text-right"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.searchDisplay = !_vm.searchDisplay
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search"
  }), _vm._v(" Buscar")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchDisplay),
      expression: "searchDisplay"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.items), function(item) {
    return (item.filters) ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('label', {
      staticClass: "control-label col-md-12"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[item.filterName].name),
        expression: "filter[item.filterName].name"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filter[item.filterName], "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((item.filters), function(filter) {
      return _c('option', {
        domProps: {
          "value": _vm.getFilter(filter, 'name')
        }
      }, [_vm._v(_vm._s(_vm.getFilter(filter, 'label')))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [(item.filterList) ? _c('span', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[item.filterName].value),
        expression: "filter[item.filterName].value"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filter[item.filterName], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option'), _vm._v(" "), _vm._l((item.filterList), function(choice) {
      return _c('option', {
        domProps: {
          "value": choice.value
        }
      }, [_vm._v(_vm._s(choice.label))])
    })], 2)]) : _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[item.filterName].value),
        expression: "filter[item.filterName].value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.filter[item.filterName].value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[item.filterName], "value", $event.target.value)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success center-block",
    on: {
      "click": function($event) {
        _vm.getData(_vm.resource)
      }
    }
  }, [_vm._v("Buscar")])], 2)])])])])]), _vm._v(" "), _c('span', {
    staticClass: "gridHideControlls"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordering),
      expression: "ordering"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.ordering)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ordering = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.paginationPlace === 'TOP' || _vm.paginationPlace === 'BOTH') ? _c('span', [_c('button', {
    attrs: {
      "disabled": _vm.pagination.previous === null
    },
    on: {
      "click": function($event) {
        _vm.getData(_vm.pagination.previous)
      }
    }
  }, [_vm._v(_vm._s(_vm.previousButtonText))]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.pagination.next === null
    },
    on: {
      "click": function($event) {
        _vm.getData(_vm.pagination.next)
      }
    }
  }, [_vm._v(_vm._s(_vm.nextButtonText))]), _vm._v("\n        Página: " + _vm._s(_vm.pagination.currentPage) + " de " + _vm._s(_vm.pagination.numPages) + " -- (Total: " + _vm._s(_vm.pagination.count) + ")\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.items), function(item) {
    return (item.showGrid !== false) ? _c('th', [_c('span', {
      staticClass: "column-ordering"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ordering === item.name),
        expression: "ordering === item.name"
      }],
      staticClass: "fa fa-sort-asc",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ordering === '-' + item.name),
        expression: "ordering === '-' + item.name"
      }],
      staticClass: "fa fa-sort-desc",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (item.ordering) ? _c('a', {
      attrs: {
        "href": "javascript:"
      },
      on: {
        "click": function($event) {
          _vm.setOrdering(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.label))]) : _c('span', [_vm._v(_vm._s(item.label))])]) : _vm._e()
  }), _vm._v(" "), (_vm.btnDetail === true) ? _c('th', [_vm._v("Ver detalle")]) : _vm._e(), _vm._v(" "), (_vm.btnEdit === true) ? _c('th', [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.btnDelete === false) ? _c('th', [_vm._v("Eliminar")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [(_vm.loadingError) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.items.length
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.errorMessage) + "\n                    ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : (_vm.isLoading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.items.length
    }
  }, [_c('emt-loading')], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._l((_vm.data), function(element) {
    return _c('tr', [_vm._l((_vm.items), function(item) {
      return (item.showGrid !== false) ? _c('td', [(_vm.getTypeof(element[item['name']]) == 'boolean') ? _c('div', [(element[item['name']]) ? _c('div', [_c('span', {
        staticClass: "glyphicon glyphicon-ok"
      })]) : _c('div')]) : (_vm.getTypeof(item['name']) == 'string') ? _c('div', [_vm._v("\n                            " + _vm._s(element[item['name']]) + "\n                        ")]) : (_vm.getTypeof(item['name']) == 'date') ? _c('div', [_vm._v("\n                            " + _vm._s(element[item['name']].substring(0, 19).replace('T', ' ')) + "\n                        ")]) : (_vm.getTypeof(item['name']) == 'object') ? _c('div', [(typeof(element[item['name']['object']][0]) !== 'undefined') ? _c('span', [_vm._v(_vm._s(element[item['name']['object']][0][item['name']['key']]))]) : _c('span', [_vm._v(_vm._s(element[item['name']['object']][item['name']['key']]))])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), (_vm.btnDetail === true) ? _c('td', [_c('router-link', {
      attrs: {
        "to": _vm.edit + element['id']
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-eye-open"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.btnEdit === true) ? _c('td', [_c('router-link', {
      attrs: {
        "to": _vm.edit + element['id']
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.btnDelete === false) ? _c('td', [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeRegister(element['id'])
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash"
    })])]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.data.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.items.length
    }
  }, [_vm._v("\n                        No se encontraron datos...\n                    ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.paginationPlace === 'BOTTOM' || _vm.paginationPlace === 'BOTH') ? _c('span', [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_vm._v("\n            Página: " + _vm._s(_vm.pagination.currentPage) + " de " + _vm._s(_vm.pagination.numPages) + " -- (Total: " + _vm._s(_vm.pagination.count) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-6 text-right"
  }, [_c('button', {
    staticClass: "btn-previous",
    attrs: {
      "disabled": _vm.pagination.previous === null
    },
    on: {
      "click": function($event) {
        _vm.getData(_vm.pagination.previous)
      }
    }
  }, [_vm._v(_vm._s(_vm.previousButtonText))]), _vm._v(" "), _c('button', {
    staticClass: "btn-next",
    attrs: {
      "disabled": _vm.pagination.next === null
    },
    on: {
      "click": function($event) {
        _vm.getData(_vm.pagination.next)
      }
    }
  }, [_vm._v(_vm._s(_vm.nextButtonText))])])]) : _vm._e()]), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "user-form",
    attrs: {
      "resource": _vm.itemresource,
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "user-grid",
    attrs: {
      "resource": _vm.config.api + '/user_full_data/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Usuarios")])])
}]}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(142),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-edit-user',
    data: function data() {
        return {
            items_form: [{
                'name': 'username',
                'label': 'Nombre de usuario',
                'placeholder': 'Ingrese nombre de usuario',
                'value': null,
                'maxlength': '30',
                'type': 'text',
                'readonly': 'readonly',
                'errors': []
            }, {
                'name': 'first_name',
                'label': 'Nombres',
                'value': null,
                'placeholder': 'Ingrese Nombres',
                'maxlength': '30',
                'type': 'text',
                'errors': []
            }, {
                'name': 'last_name',
                'label': 'Apellidos',
                'value': null,
                'placeholder': 'Ingrese Apellidos',
                'maxlength': '30',
                'type': 'text',
                'errors': []
            }, {
                'name': 'email',
                'label': 'Correo electrónico principal',
                'value': null,
                'placeholder': 'Ingrese Correo electrónico principal',
                'maxlength': '254',
                'type': 'text',
                'errors': []
            }, {
                'name': 'email_alternative',
                'label': 'Correo electrónico alternativo',
                'value': null,
                'placeholder': 'Ingrese correo electrónico alternativo',
                'maxlength': '200',
                'type': 'text',
                'errors': []
            }, {
                'name': 'group',
                'label': 'Perfil',
                'placeholder': 'Seleccione un perfil',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'unit',
                'label': 'Unidad',
                'placeholder': 'Seleccione una unidad',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'visible': false
            }, {
                'name': 'company',
                'label': 'Empresa o filial',
                'placeholder': 'Seleccione una empresa o filial',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'visible': false
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }, {
                'name': 'password',
                'label': '',
                'placeholder': 'Ingrese contraseña',
                'value': null,
                'maxlength': '30',
                'type': 'password',
                'errors': []
            }],
            itemresource: [{
                'resourceUser': '/user/'
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: true,
            group: '',
            unit: '',
            company: ''
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getGroup();
        this.getUnits();
        this.getCompany();
        this.getData(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/user_full_data/?id=');
    },
    methods: {
        getData: function getData(url) {
            url = url + this.$route.params.id;
            var self = this;
            self.$http.get(url).then(function (response) {
                self.setValue(response.body.results[0]);
            }, function (response) {});
        },
        setValue: function setValue(value) {
            for (var form in this.items_form) {
                if (this.items_form[form].name === 'unit' && value['unit_user'] !== null) {
                    this.unit = value['unit_user'].unit;
                    document.getElementsByName('unit')[0].value = this.unit;
                    if (document.getElementsByName('unit')[0].value !== '') {
                        this.items_form[form].value = value['unit_user'].unit;
                        this.items_form[form].visible = true;
                    } else {
                        this.items_form[form].value = '';
                    }
                } else if (this.items_form[form].name === 'company' && value['company_user'] !== null) {
                    this.company = value['company_user'].company;
                    document.getElementsByName('company')[0].value = this.company;
                    if (document.getElementsByName('company')[0].value !== '') {
                        this.items_form[form].value = value['company_user'].company;
                        this.items_form[form].visible = true;
                    } else {
                        this.items_form[form].value = '';
                    }
                } else {
                    if (this.items_form[form].name === 'group') {
                        this.group = value.groups[0].id;
                        document.getElementsByName('group')[0].options.selectedIndex = this.group;
                        this.items_form[form].value = this.group;
                        continue;
                    } else {
                        var valueuser = value;
                        var item = this.items_form[form].name;
                        this.items_form[form].value = valueuser[item];
                    }
                }
            }
        },
        getUnits: function getUnits() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/unit/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.items_form[6].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },
        getGroup: function getGroup() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/group/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.items_form[5].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },
        getCompany: function getCompany() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/company/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.items_form[7].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    mounted: function mounted() {
        document.getElementsByName('password')[0].style.display = 'none';
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user___default.a
    }
});

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('emt-form', {
    ref: "user-form",
    attrs: {
      "resource": _vm.itemresource,
      "items": _vm.items_form,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar Usuario")])])
}]}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-unit',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre unidad',
                'placeholder': 'Ingrese nombre de unidad',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'notification',
                'label': 'Alerta inicial (Días)',
                'placeholder': 'Alerta inicial (Días)',
                'value': null,
                'maxlength': '2',
                'type': 'text',
                'errors': []
            }, {
                'name': 'notification_end',
                'label': 'Alerta final (Días)',
                'placeholder': 'Alerta final (Días)',
                'value': null,
                'maxlength': '2',
                'type': 'text',
                'errors': []
            }, {
                'name': 'days',
                'label': 'Días ANS',
                'value': null,
                'placeholder': 'Días ANS',
                'maxlength': '2',
                'type': 'text',
                'errors': []
            }],
            itemsGrid: [{
                'name': 'name',
                'label': 'Nombre unidad',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'notification',
                'label': 'Alerta inicial (Días)',
                'ordering': true,
                'filters': ['exact']
            }, {
                'name': 'notification_end',
                'label': 'Alerta final (Días)',
                'ordering': true,
                'filters': ['exact']
            }, {
                'name': 'days',
                'label': 'Días ANS',
                'ordering': true,
                'filters': ['exact']
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'ordering': true
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/Unit/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/unit/'
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['unit-grid'].reload();
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_components_emt_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_components_emt_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_input_components_emt_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_input_components_emt_checkbox__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_input_components_emt_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_input_components_emt_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_radio__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_select__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_textarea__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form',
    data: function data() {
        return {
            data: {
                form_values: {},
                errors: []
            },
            isLoading: false
        };
    },
    props: {
        resource: String,
        items: Array,
        updateData: Boolean
    },
    methods: {
        getFormValues: function getFormValues() {
            var self = this;
            self.data.form_values = {};
            for (var i = 0; i < self.items.length; i++) {
                var value = null;
                if (typeof self.items[i].value === 'string') {
                    value = self.items[i].value != null ? self.items[i].value.trim() : null;
                } else {
                    value = self.items[i].value;
                }
                self.data.form_values[self.items[i].name] = value;
            }
            return self.data.form_values;
        },

        clearFormValues: function clearFormValues() {
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].type === 'checkbox' || this.items[i].type === 'radio') {
                    this.items[i].value = false;
                } else if (this.items[i].type === 'select') {
                    this.items[i].selectedIndex = 0;
                    this.items[i].value = '';
                } else if (this.items[i].type === 'date') {
                    document.getElementsByName('date')[0].value = null;
                } else {
                    this.items[i].value = '';
                }
            }
            for (i in this.items) {
                this.items[i].errors = [];
            }
            return null;
        },

        register: function register(table) {
            var self = this;
            var values = self.getFormValues();
            self.isLoading = true;
            self.$http.post(self.resource, values).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a({
                    title: 'Se creó el registro exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                self.clearFormValues();
                self.$emit('register');
            }, function (response) {
                self.data.errors = response.body;
                var prop = null;
                for (var i in self.items) {
                    self.items[i].errors = [];
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            self.items[i].errors = response.body[prop];
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
                self.isLoading = false;
            });
            self.isLoading = false;
        },
        updateDate: function updateDate(value) {
            for (var item in this.items) {
                value = value.toISOString().substring(0, 10);
                this.items[item].value = value;
            }
        },
        update: function update() {
            var self = this;
            var values = self.getFormValues();
            self.isLoading = true;
            self.$http.put(self.resource + this.$route.params.id + '/', values).then(function (response) {
                self.isLoading = false;
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a({
                    title: 'Se realizó la actualización exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].go(-1);
            }, function (response) {
                self.data.errors = response.body;
                self.isLoading = false;
                var prop = null;
                for (var i in self.items) {
                    self.items[i].errors = [];
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            self.items[i].errors = response.body[prop];
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
        },
        behind: function behind() {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].go(-1);
        },
        cancel: function cancel() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a({
                title: '¿Está seguro de cancelar?',
                text: 'Al cancelar se limpiarán todos los campos diligenciados.',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No'
            }).then(function (result) {
                console.log('result: ', result);
                if (result) {
                    self.clearFormValues();
                }
            });
        },
        listener: function listener(e) {
            var self = this;
            var containSwal = document.body.classList.contains('swal2-shown');
            if (e.key === 'Enter' && !containSwal) {
                if (self.updateData) {
                    self.update();
                } else {
                    self.register();
                }
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        window.addEventListener('keyup', self.listener);
    },
    destroyed: function destroyed() {
        var self = this;
        window.removeEventListener('keyup', self.listener);
    },
    components: {
        'emt-input': __WEBPACK_IMPORTED_MODULE_2__components_input_components_emt_input___default.a,
        'emt-checkbox': __WEBPACK_IMPORTED_MODULE_3__components_input_components_emt_checkbox___default.a,
        'emt-radio': __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_radio___default.a,
        'emt-select': __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_select___default.a,
        'emt-textarea': __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_textarea___default.a,
        'datepicker': __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a
    }
});

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post",
      "action": "",
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.items), function(item, key) {
    return _c('div', [(item.type === 'text' || item.type === 'number' || item.type === 'password' || item.type === 'file') ? _c('emt-input', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('emt-radio', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('emt-select', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'checkbox') ? _c('emt-checkbox', {
      attrs: {
        "item": item,
        "className": 'col-md-1'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'textarea') ? _c('emt-textarea', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "yyyy-MM-dd",
        "disabled": item.disabled
      },
      on: {
        "input": _vm.updateDate
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((item.errors), function(error) {
      return (item.type === 'date') ? _c('div', {
        staticStyle: {
          "margin-left": "18px"
        },
        attrs: {
          "id": "errors"
        }
      }, [_c('div', {
        staticClass: "clearfix"
      }), _vm._v("\n                " + _vm._s(error) + "\n            ")]) : _vm._e()
    }), _vm._v(" "), ((key + 1) % 3 === 0) ? _c('div', {
      staticClass: "clearfix"
    }, [_c('br')]) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [(_vm.updateData) ? _c('div', [_c('input', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "value": "Atrás",
      "name": "Atrás"
    },
    on: {
      "click": _vm.behind
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Actualizar",
      "name": "Actualizar"
    },
    on: {
      "click": _vm.update,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.update($event)
      }
    }
  }) : _c('span', [_vm._v("Cargando...")])]) : _c('div', [_c('input', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "value": "Cancelar",
      "name": "Cancelar"
    },
    on: {
      "click": _vm.cancel
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button",
      "value": "Guardar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.register
    }
  }) : _c('span', [_vm._v("Cargando...")])])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "unit-form",
    attrs: {
      "resource": _vm.config.api + '/unit/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "unit-grid",
    attrs: {
      "resource": _vm.config.api + '/unit/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Unidad")])])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-edit-unit',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre unidad',
                'placeholder': 'Ingrese nombre de unidad',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'notification',
                'label': 'Alerta inicial (Días)',
                'placeholder': 'Alerta inicial (Días)',
                'value': null,
                'maxlength': '2',
                'type': 'text',
                'errors': []
            }, {
                'name': 'notification_end',
                'label': 'Alerta final (Días)',
                'placeholder': 'Alerta final (Días)',
                'value': null,
                'maxlength': '2',
                'type': 'text',
                'errors': []
            }, {
                'name': 'days',
                'label': 'Días ANS',
                'value': null,
                'placeholder': 'Días ANS',
                'maxlength': '2',
                'type': 'text',
                'errors': []
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: true
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getData(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/unit/');
    },
    methods: {
        getData: function getData(url) {
            url = url + this.$route.params.id + '/';
            var self = this;
            self.$http.get(url).then(function (response) {
                self.setValue(response.body);
            }, function (response) {});
        },
        setValue: function setValue(value) {
            for (var form in this.itemsForm) {
                this.itemsForm[form].value = value[this.itemsForm[form].name];
            }
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a
    }
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "unit-form",
    attrs: {
      "resource": _vm.config.api + '/unit/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar Unidad")])])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-area',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre área',
                'placeholder': 'Ingrese nombre de área',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'unit',
                'label': 'Unidad',
                'placeholder': 'Seleccione una unidad',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'responsible',
                'label': 'Responsable',
                'placeholder': 'Seleccione responsable',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'boss',
                'label': 'Jefe',
                'placeholder': 'Seleccione jefe',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }],
            itemsGrid: [{
                'name': 'name',
                'label': 'Nombre área',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'unit',
                    'key': 'name'
                },
                'label': 'Unidad',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'responsible',
                    'key': 'username'
                },
                'label': 'Responsable',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'boss',
                    'key': 'username'
                },
                'label': 'Jefe',
                'value': null,
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': null,
                'ordering': true
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/area/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/area/'
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['area-grid'].reload();
        },

        getUnits: function getUnits() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getResponsible: function getResponsible() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/user/?nopaginate=1&is_active=true&ordering=name&groups=3').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[2].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getBoss: function getBoss() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/user/?nopaginate=1&is_active=true&ordering=name&groups=3').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[3].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getUnits();
        this.getResponsible();
        this.getBoss();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "area-form",
    attrs: {
      "resource": _vm.config.api + '/area/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "area-grid",
    attrs: {
      "resource": _vm.config.api + '/area_full_data/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Áreas")])])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-edit-area',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre área',
                'placeholder': 'Ingrese nombre de área',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'unit',
                'label': 'Unidad',
                'placeholder': 'Seleccione una unidad',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'responsible',
                'label': 'Responsable',
                'placeholder': 'Seleccione responsable',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'boss',
                'label': 'Jefe',
                'placeholder': 'Seleccione jefe',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: true
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getUnits();
    },
    methods: {
        getData: function getData(url) {
            url = url + this.$route.params.id + '/';
            var self = this;
            self.$http.get(url).then(function (response) {
                self.setValue(response.body);
            }, function (response) {});
        },
        setValue: function setValue(value) {
            var self = this;
            for (var form in self.itemsForm) {
                if (self.itemsForm[form].name === 'unit' || self.itemsForm[form].name === 'responsible' || self.itemsForm[form].name === 'boss') {
                    var activeOptions = self.itemsForm[form].select_options;
                    var flag = false;
                    for (var i = 0; i < activeOptions.length; i++) {
                        if (activeOptions[i].value === value[self.itemsForm[form].name]) {
                            self.itemsForm[form].value = value[self.itemsForm[form].name];
                            flag = true;
                        }
                    }
                    if (!flag) {
                        self.itemsForm[form].value = '';
                    }
                } else {
                    self.itemsForm[form].value = value[self.itemsForm[form].name];
                }
            }
        },

        getUnits: function getUnits() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
                this.getResponsible();
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getResponsible: function getResponsible() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/user/?nopaginate=1&is_active=true&ordering=name&groups=3').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[2].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    });
                }
                this.getBoss();
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getBoss: function getBoss() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/user/?nopaginate=1&is_active=true&ordering=name&groups=3').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[3].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    });
                }
                this.getData(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/area/');
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a
    }
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "area-form",
    attrs: {
      "resource": _vm.config.api + '/area/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar área")])])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-reason',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Motivo',
                'placeholder': 'Ingrese motivo',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'area',
                'label': 'Área',
                'placeholder': 'Seleccione una área',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }],
            itemsGrid: [{
                'name': 'name',
                'label': 'Motivo',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'area',
                    'key': 'name'
                },
                'label': 'Área',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': null,
                'ordering': true
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/EditReason/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/reason/'
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['reason-grid'].reload();
        },

        getArea: function getArea() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/area/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getArea();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "reason-form",
    attrs: {
      "resource": _vm.config.api + '/reason/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "reason-grid",
    attrs: {
      "resource": _vm.config.api + '/reason_full_data/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Motivos")])])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-edit-reason',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Motivo',
                'placeholder': 'Ingrese motivo',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'area',
                'label': 'Área',
                'placeholder': 'Seleccione una área',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: true
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getArea();
    },
    methods: {
        getData: function getData(url) {
            url = url + this.$route.params.id + '/';
            var self = this;
            self.$http.get(url).then(function (response) {
                self.setValue(response.body);
            }, function (response) {});
        },
        setValue: function setValue(value) {
            var self = this;
            for (var form in this.itemsForm) {
                if (this.itemsForm[form].name === 'area') {
                    var activeOptions = self.itemsForm[form].select_options;
                    var flag = false;
                    for (var i = 0; i < activeOptions.length; i++) {
                        if (activeOptions[i].value === value[self.itemsForm[form].name]) {
                            self.itemsForm[form].value = value[self.itemsForm[form].name];
                            flag = true;
                        }
                    }
                    if (!flag) {
                        self.itemsForm[form].value = '';
                    }
                } else {
                    this.itemsForm[form].value = value[this.itemsForm[form].name];
                }
            }
        },

        getArea: function getArea() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/area/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
                this.getData(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/reason/');
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a
    }
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "reason-form",
    attrs: {
      "resource": _vm.config.api + '/reason/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar Motivo")])])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-subreason',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Submotivo',
                'placeholder': 'Ingrese submotivo',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'reason',
                'label': 'Motivo',
                'placeholder': 'Seleccione un motivo',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }],
            itemsGrid: [{
                'name': 'name',
                'label': 'Submotivo',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'reason',
                    'key': 'name'
                },
                'label': 'Motivo',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': null,
                'ordering': true
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/subreason/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/subreason/'
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['subreason-grid'].reload();
        },

        getReason: function getReason() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/reason/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getReason();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "subreason-form",
    attrs: {
      "resource": _vm.config.api + '/subreason/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "subreason-grid",
    attrs: {
      "resource": _vm.config.api + '/subreason_full_data/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Submotivos")])])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-edit-subreason',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Submotivo',
                'placeholder': 'Ingrese submotivo',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'reason',
                'label': 'Motivo',
                'placeholder': 'Seleccione un motivo',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: true
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getReason();
    },
    methods: {
        getData: function getData(url) {
            url = url + this.$route.params.id + '/';
            var self = this;
            self.$http.get(url).then(function (response) {
                self.setValue(response.body);
            }, function (response) {});
        },
        setValue: function setValue(value) {
            var self = this;
            for (var form in this.itemsForm) {
                if (this.itemsForm[form].name === 'reason') {
                    var activeOptions = self.itemsForm[form].select_options;
                    var flag = false;
                    for (var i = 0; i < activeOptions.length; i++) {
                        if (activeOptions[i].value === value[self.itemsForm[form].name]) {
                            self.itemsForm[form].value = value[self.itemsForm[form].name];
                            flag = true;
                        }
                    }
                    if (!flag) {
                        self.itemsForm[form].value = '';
                    }
                } else {
                    this.itemsForm[form].value = value[this.itemsForm[form].name];
                }
            }
        },

        getReason: function getReason() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/reason/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
                this.getData(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/subreason/');
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a
    }
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "subreason-form",
    attrs: {
      "resource": _vm.config.api + '/subreason/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar Submotivo")])])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-company',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Empresa o filial',
                'placeholder': 'Ingrese nombre de empresa o filial',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }],
            itemsGrid: [{
                'name': 'name',
                'label': 'Empresa o filial',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'ordering': true
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/company/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/company/'
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['company-grid'].reload();
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "company-form",
    attrs: {
      "resource": _vm.config.api + '/company/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "company-grid",
    attrs: {
      "resource": _vm.config.api + '/company/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Empresa o Filial")])])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-edit-company',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre empresa o filial',
                'placeholder': 'Ingrese nombre de empresa o filial',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: true
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getData(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/company/');
    },
    methods: {
        getData: function getData(url) {
            url = url + this.$route.params.id + '/';
            var self = this;
            self.$http.get(url).then(function (response) {
                self.setValue(response.body);
            }, function (response) {});
        },
        setValue: function setValue(value) {
            for (var form in this.itemsForm) {
                this.itemsForm[form].value = value[this.itemsForm[form].name];
            }
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a
    }
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "unit-form",
    attrs: {
      "resource": _vm.config.api + '/company/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar empresa o filial")])])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-channel',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre canal',
                'placeholder': 'Ingrese nombre de canal',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }],
            itemsGrid: [{
                'name': 'name',
                'label': 'Canal',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'ordering': true
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/channel/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/channel/'
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['channel-grid'].reload();
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "channel-form",
    attrs: {
      "resource": _vm.config.api + '/channel/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "channel-grid",
    attrs: {
      "resource": _vm.config.api + '/channel/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Canales")])])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-edit-channel',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre canal',
                'placeholder': 'Ingrese nombre de canal',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: true
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getData(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/channel/');
    },
    methods: {
        getData: function getData(url) {
            url = url + this.$route.params.id + '/';
            var self = this;
            self.$http.get(url).then(function (response) {
                self.setValue(response.body);
            }, function (response) {});
        },
        setValue: function setValue(value) {
            for (var form in this.itemsForm) {
                this.itemsForm[form].value = value[this.itemsForm[form].name];
            }
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a
    }
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "unit-form",
    attrs: {
      "resource": _vm.config.api + '/channel/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar canal")])])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-date-not-available',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'date',
                'label': 'Fecha',
                'class': 'form-control txb-calendar',
                'divclass': 'col-md-3',
                'placeholder': 'Ingrese fecha',
                'value': null,
                'maxlength': '50',
                'type': 'date',
                'disabled': {
                    'to': new Date()
                },
                'errors': []
            }],
            itemsGrid: [{
                'name': 'date',
                'label': 'Fecha',
                'ordering': true,
                'filters': ['exact']
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/DateNotAvailable/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/date_not_available/',
            btnEdit: false,
            btnDelete: false
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['date-grid'].reload();
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "date-form",
    attrs: {
      "resource": _vm.config.api + '/date_not_available/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "date-grid",
    attrs: {
      "resource": _vm.config.api + '/date_not_available/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl,
      "btnEdit": _vm.btnEdit,
      "btnDelete": _vm.btnDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Días no hábiles")])])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-consult-pqr',
    data: function data() {
        return {
            consult: 'consult',
            itemsGrid: [{
                'name': 'id',
                'label': 'ID PQR',
                'ordering': true,
                'filters': ['exact']
            }, {
                'name': 'status_display',
                'label': 'Estado PQR',
                'ordering': true,
                'filters': ['exact'],
                'filterList': __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].statusPqrList
            }, {
                'name': {
                    'object': 'type',
                    'key': 'name'
                },
                'label': 'Tipo PQR',
                'value': null,
                'ordering': true
            }, {
                'name': {
                    'object': 'reason',
                    'key': 'name'
                },
                'label': 'Motivo',
                'value': null,
                'ordering': true
            }, {
                'name': {
                    'object': 'subreason',
                    'key': 'name'
                },
                'label': 'Submotivo',
                'value': null,
                'ordering': true
            }, {
                'name': 'account__document',
                'label': 'Cédula',
                'value': null,
                'showGrid': false,
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'account',
                    'key': 'document'
                },
                'label': 'Cédula',
                'value': null,
                'ordering': true
            }, {
                'name': 'account__name',
                'label': 'Nombres',
                'value': null,
                'showGrid': false,
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'account',
                    'key': 'name'
                },
                'label': 'Nombres',
                'value': null,
                'ordering': true
            }, {
                'name': 'account__surname',
                'label': 'Apellidos',
                'value': null,
                'ordering': true,
                'showGrid': false,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'account',
                    'key': 'surname'
                },
                'label': 'Apellidos',
                'value': null,
                'ordering': true
            }, {
                'name': {
                    'object': 'unit',
                    'key': 'name'
                },
                'label': 'Unidad',
                'value': null,
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'area',
                    'key': 'name'
                },
                'label': 'Área',
                'value': null,
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': {
                    'object': 'company',
                    'key': 'name'
                },
                'label': 'Empresa o filial',
                'value': null,
                'ordering': true
            }, {
                'name': 'waiting_provider',
                'label': 'Espera de proveedor',
                'ordering': true
            }, {
                'name': 'created_at',
                'label': 'Fecha creación',
                'ordering': true
            }, {
                'name': 'date_expiry',
                'label': 'Fecha expiración',
                'ordering': true
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/UpdatePqr/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr/',
            btnDelete: true,
            btnEdit: false,
            btnDetail: true,
            idAreas: [],
            gridUrl: null
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['pqr-grid'].reload();
        },
        areas: function areas() {
            return this.idAreas.join(',');
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        var self = this;
        if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('perfil') === 'Administrador') {
            self.gridUrl = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr_full_data/';
        } else if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('perfil') !== 'Consulta filial') {
            if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('perfil') === 'Emtelco') {
                self.gridUrl = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr_full_data/';
            } else {
                self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/unit_user/?unit_user=' + __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('idUser')).then(function (response) {
                    self.gridUrl = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr_full_data/?unit__in=' + response.body.results[0].unit.id;
                    self.reload();
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
                });
            }
        } else if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('perfil') === 'Consulta filial') {
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/company_user/?company_user=' + __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('idUser')).then(function (response) {
                self.gridUrl = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr_full_data/?company=' + response.body.results[0].company.id;
                self.reload();
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        } else {
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/unit_user/?unit_user=' + __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('idUser')).then(function (response) {
                self.gridUrl = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr_full_data/?unit__in=' + response.body.results[0].unit.id;
                self.reload();
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-grid', {
    ref: "pqr-grid",
    attrs: {
      "resource": _vm.gridUrl,
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl,
      "btnDelete": _vm.btnDelete,
      "btnEdit": _vm.btnEdit,
      "btnDetail": _vm.btnDetail,
      "source": _vm.consult
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Consultar PQR")])])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_form_pqr__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_form_pqr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_form_pqr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_loading__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-register-pqr',
    data: function data() {
        return {
            itemsFormPqr: [{
                'name': 'type',
                'label': 'Tipo PQR',
                'placeholder': 'Seleccione tipo PQR',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'unit',
                'label': 'Unidad',
                'placeholder': 'Seleccione una unidad',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'dependencies': ['area', 'reason', 'subreason', 'user_assigned']
            }, {
                'name': 'area',
                'label': 'Área',
                'placeholder': 'Seleccione área',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'dependencies': ['reason', 'subreason', 'user_assigned']
            }, {
                'name': 'reason',
                'label': 'Motivo',
                'placeholder': 'Seleccione motivo',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'dependencies': ['subreason']
            }, {
                'name': 'subreason',
                'label': 'Submotivo',
                'placeholder': 'Seleccione submotivo',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'user_assigned',
                'label': 'Usuario asignado',
                'placeholder': 'Seleccione usuario',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'channel',
                'label': 'Canal',
                'placeholder': 'Seleccione canal',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'company',
                'label': 'Empresa o filial',
                'placeholder': 'Seleccione empresa',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'process',
                'label': 'Referencia',
                'placeholder': 'Ingrese referencia',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': []
            }, {
                'name': 'gender',
                'label': 'Género',
                'placeholder': 'Seleccione el género',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': []
            }, {
                'name': 'note',
                'label': 'Descripción',
                'placeholder': 'Ingrese Descripción de la pqr',
                'value': null,
                'maxlength': '5000',
                'type': 'textarea',
                'rows': '1',
                'cols': '1',
                'errors': []
            }],
            itemsFormAccount: [{
                'name': 'document',
                'label': 'Documento',
                'placeholder': 'Ingrese Documento',
                'maxlength': '15',
                'value': null,
                'type': 'text',
                'errors': []
            }, {
                'name': 'name',
                'label': 'Nombres',
                'placeholder': 'Ingrese nombres',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': []
            }, {
                'name': 'surname',
                'label': 'Apellidos',
                'placeholder': 'Ingrese Apellidos',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': []
            }, {
                'name': 'phone_number',
                'label': 'Teléfono',
                'placeholder': 'Ingrese número telefónico',
                'maxlength': '10',
                'value': null,
                'type': 'text',
                'errors': []
            }, {
                'name': 'cellphone_number',
                'label': 'Celular',
                'placeholder': 'Ingrese Celular',
                'maxlength': '10',
                'value': null,
                'type': 'text',
                'errors': []
            }, {
                'name': 'email',
                'label': 'Email',
                'placeholder': 'Ingrese correo electrónico',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': []
            }],
            itemsFormAttachment: [{
                'name': 'attachment',
                'label': 'Adjunto',
                'placeholder': 'Seleccione Archivo a adjuntar',
                'value': null,
                'type': 'file',
                'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                'maximumSize': 20,
                'errors': []
            }],
            itemResource: [{
                'resourceAccount': '/account/',
                'resourcePqr': '/pqr/',
                'resourceAttachment': '/attachment/'
            }],
            update: false,
            typeactivity: 'register'
        };
    },
    methods: {
        changelist: function changelist(item) {
            var itemSelected = __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(item.select_options, 'value', item.value);
            itemSelected = itemSelected === null || itemSelected === undefined ? { id: '', value: '' } : itemSelected;
            var callbackObject = {};
            switch (item.name) {
                case 'unit':
                    callbackObject = {
                        functions: [this.getArea],
                        arguments: [itemSelected.id]
                    };
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].clearSelect(this.itemsFormPqr, item, callbackObject);
                    break;
                case 'area':
                    callbackObject = {
                        functions: [this.getReason, this.getUserAssigned],
                        arguments: [itemSelected.id, itemSelected.responsible]
                    };
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].clearSelect(this.itemsFormPqr, item, callbackObject);
                    break;
                case 'reason':
                    callbackObject = {
                        functions: [this.getSubreason],
                        arguments: [itemSelected.id]
                    };
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].clearSelect(this.itemsFormPqr, item, callbackObject);
                    break;
            }
        },
        getType: function getType() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/pqr_type/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[0].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getUnits: function getUnits() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[1].value = '';
                    self.itemsFormPqr[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name,
                        id: response.body[data].id
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getArea: function getArea(value) {
            var self = this;
            if (self.itemsFormPqr[1].value !== undefined && self.itemsFormPqr[1].value !== null || self.itemsFormPqr[1].value > 0) {
                var id = value;

                self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/area/?nopaginate=1&is_active=true&ordering=name&unit=' + id).then(function (response) {
                    self.itemsFormPqr[2].value = '';
                    self.itemsFormPqr[2].select_options = [];
                    for (var data in response.body) {
                        self.itemsFormPqr[2].select_options.push({
                            value: response.body[data].url,
                            text: response.body[data].name,
                            id: response.body[data].id,
                            responsible: response.body[data].responsible
                        });
                    }
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
                });
            }
        },

        getReason: function getReason(value) {
            var self = this;
            if (self.itemsFormPqr[2].value !== undefined && self.itemsFormPqr[2].value !== null || self.itemsFormPqr[2].value > 0) {
                var id = value;

                self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/reason/?nopaginate=1&is_active=true&ordering=name&area=' + id).then(function (response) {
                    self.itemsFormPqr[3].value = '';
                    self.itemsFormPqr[3].select_options = [];
                    for (var data in response.body) {
                        self.itemsFormPqr[3].select_options.push({
                            value: response.body[data].url,
                            text: response.body[data].name,
                            id: response.body[data].id
                        });
                    }
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
                });
            }
        },

        getSubreason: function getSubreason(value) {
            var self = this;
            if (self.itemsFormPqr[3].value !== undefined && self.itemsFormPqr[3].value !== null || self.itemsFormPqr[3].value > 0) {
                var id = value;
                self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/subreason/?nopaginate=1&is_active=true&ordering=name&reason=' + id).then(function (response) {
                    self.itemsFormPqr[4].value = '';
                    self.itemsFormPqr[4].select_options = [];
                    for (var data in response.body) {
                        self.itemsFormPqr[4].select_options.push({
                            value: response.body[data].url,
                            text: response.body[data].name,
                            id: response.body[data].id
                        });
                    }
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
                });
            }
        },

        getUserAssigned: function getUserAssigned(value) {
            var self = this;
            self.$http.get(value).then(function (response) {
                if (response.body.is_active === true) {
                    self.itemsFormPqr[5].value = '';
                    self.itemsFormPqr[5].select_options = [{
                        value: response.body['url'],
                        text: response.body['username']
                    }];
                }
            });
        },

        getChannel: function getChannel() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/channel/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[6].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getCompany: function getCompany() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/company/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[7].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getGender: function getGender() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/gender/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[9].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_3__generic__["a" /* default */].setToken();
        this.getType();
        this.getUnits();
        this.getChannel();
        this.getCompany();
        this.getGender();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_5__components_emt_form_pqr___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_6__components_emt_loading___default.a
    }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_checkbox__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_radio__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_input_components_emt_select__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_input_components_emt_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_input_components_emt_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_input_components_emt_textarea__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_input_components_emt_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_input_components_emt_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_input_components_emt_file__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_input_components_emt_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_input_components_emt_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-pqr',
    data: function data() {
        return {
            data: {
                form_valuesPqr: {},
                form_valuesAccount: {},
                form_valuesAttachment: {},
                form_valuesActivity: {},
                form_valuesActivityAttachment: {},
                form_valuesActivityProvider: {},
                form_valuesProviderAttachment: {},
                form_valuesActivityClosed: {},
                form_valuesClosedAttachment: {},
                form_valuesActivityReassignment: {},
                errors: []
            },
            Cookies: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a,
            isLoading: false
        };
    },
    props: {
        resource: Array,
        itemsFormAccount: Array,
        itemsFormPqr: Array,
        itemsFormAttachment: Array,
        itemsFormActivity: Array,
        itemsFormActivityAttachment: Array,
        itemsFormActivityProvider: Array,
        itemsFormProviderAttachment: Array,
        itemsFormActivityClosed: Array,
        itemsFormClosedAttachment: Array,
        itemsFormActivityReassignment: Array,
        typeactivity: String,
        updateData: Boolean
    },
    methods: {
        getFormValuesAccount: function getFormValuesAccount() {
            var self = this;
            self.data.form_valuesAccount = {};
            for (var i = 0; i < self.itemsFormAccount.length; i++) {
                var value = null;
                if (typeof self.itemsFormAccount[i].value === 'string') {
                    value = self.itemsFormAccount[i].value != null ? self.itemsFormAccount[i].value.trim() : null;
                } else {
                    value = self.itemsFormAccount[i].value;
                }
                self.data.form_valuesAccount[self.itemsFormAccount[i].name] = value;
            }
            return self.data.form_valuesAccount;
        },
        getFormValuesPQR: function getFormValuesPQR() {
            var self = this;
            self.data.form_valuesPqr = {};
            for (var i = 0; i < self.itemsFormPqr.length; i++) {
                var value = null;
                if (typeof self.itemsFormPqr[i].value === 'string') {
                    value = self.itemsFormPqr[i].value != null ? self.itemsFormPqr[i].value.trim() : null;
                } else {
                    value = self.itemsFormPqr[i].value;
                }
                self.data.form_valuesPqr[self.itemsFormPqr[i].name] = value;
            }
            return self.data.form_valuesPqr;
        },
        getFormValuesAttachment: function getFormValuesAttachment() {
            var self = this;
            self.data.form_valuesAttachment = [];
            for (var i = 0; i < self.itemsFormAttachment[0].value.length; i++) {
                self.data.form_valuesAttachment.push(self.itemsFormAttachment[0].value[i]);
            }
            return self.data.form_valuesAttachment;
        },
        getFormValuesActivityAttachment: function getFormValuesActivityAttachment() {
            var self = this;
            self.data.form_valuesActivityAttachment = [];
            for (var i = 0; i < self.itemsFormActivityAttachment[0].value.length; i++) {
                self.data.form_valuesActivityAttachment.push(self.itemsFormActivityAttachment[0].value[i]);
            }
            return self.data.form_valuesActivityAttachment;
        },
        getFormValuesProviderAttachment: function getFormValuesProviderAttachment() {
            var self = this;
            self.data.form_valuesProviderAttachment = [];
            for (var i = 0; i < self.itemsFormProviderAttachment[0].value.length; i++) {
                self.data.form_valuesProviderAttachment.push(self.itemsFormProviderAttachment[0].value[i]);
            }
            return self.data.form_valuesProviderAttachment;
        },
        getFormValuesClosedAttachment: function getFormValuesClosedAttachment() {
            var self = this;
            self.data.form_valuesClosedAttachment = [];
            for (var i = 0; i < self.itemsFormClosedAttachment[0].value.length; i++) {
                self.data.form_valuesClosedAttachment.push(self.itemsFormClosedAttachment[0].value[i]);
            }
            return self.data.form_valuesClosedAttachment;
        },
        getFormValuesActivity: function getFormValuesActivity() {
            var self = this;
            self.data.form_valuesActivity = {};
            for (var i = 0; i < self.itemsFormActivity.length; i++) {
                var value = null;
                if (typeof self.itemsFormActivity[i].value === 'string') {
                    value = self.itemsFormActivity[i].value != null ? self.itemsFormActivity[i].value.trim() : null;
                } else {
                    value = self.itemsFormActivity[i].value;
                }
                self.data.form_valuesActivity[self.itemsFormActivity[i].name] = value;
            }
            return self.data.form_valuesActivity;
        },
        getFormValuesActivityProvider: function getFormValuesActivityProvider() {
            var self = this;
            self.data.form_valuesActivityProvider = {};
            for (var i = 0; i < self.itemsFormActivityProvider.length; i++) {
                var value = null;
                if (typeof self.itemsFormActivityProvider[i].value === 'string') {
                    value = self.itemsFormActivityProvider[i].value != null ? self.itemsFormActivityProvider[i].value.trim() : null;
                } else {
                    value = self.itemsFormActivityProvider[i].value;
                }
                self.data.form_valuesActivityProvider[self.itemsFormActivityProvider[i].name] = value;
            }
            return self.data.form_valuesActivityProvider;
        },
        getFormValuesActivityClosed: function getFormValuesActivityClosed() {
            var self = this;
            self.data.form_valuesActivityClosed = {};
            for (var i = 0; i < self.itemsFormActivityClosed.length; i++) {
                var value = null;
                if (typeof self.itemsFormActivityClosed[i].value === 'string') {
                    value = self.itemsFormActivityClosed[i].value != null ? self.itemsFormActivityClosed[i].value.trim() : null;
                } else {
                    value = self.itemsFormActivityClosed[i].value;
                }
                self.data.form_valuesActivityClosed[self.itemsFormActivityClosed[i].name] = value;
            }
            return self.data.form_valuesActivityClosed;
        },
        getFormValuesReassignment: function getFormValuesReassignment() {
            var self = this;
            self.data.form_valuesActivityReassignment = {};
            for (var i = 0; i < self.itemsFormActivityReassignment.length; i++) {
                var value = null;
                if (typeof self.itemsFormActivityReassignment[i].value === 'string') {
                    value = self.itemsFormActivityReassignment[i].value != null ? self.itemsFormActivityReassignment[i].value.trim() : null;
                } else {
                    value = self.itemsFormActivityReassignment[i].value;
                }
                self.data.form_valuesActivityReassignment[self.itemsFormActivityReassignment[i].name] = value;
            }
            return self.data.form_valuesActivityReassignment;
        },
        register: function register() {
            var self = this;
            self.isLoading = true;
            var valuesAccount = self.getFormValuesAccount();
            var valuesPQR = self.getFormValuesPQR();
            var valuesAttachment = self.getFormValuesAttachment();
            var values = {};
            values['account'] = valuesAccount;
            values['pqr'] = valuesPQR;
            var arrayAttachment = [];
            for (var i = 0; i < valuesAttachment.length; i++) {
                var itemAttachment = {};
                itemAttachment['name'] = valuesAttachment[i].name;
                itemAttachment['attachment'] = valuesAttachment[i].asBase64;
                arrayAttachment.push(itemAttachment);
            }
            if (arrayAttachment.length > 0) {
                values['file'] = arrayAttachment;
            }
            self.$http.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].create_pqr, values).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                    title: 'Se guardó la PQR exitosamente',
                    text: 'Con el ID: ' + response.body.id,
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/ConsultPqr');
                self.isLoading = false;
            }, function (response) {
                self.data.errors = response.body.detail;
                if (response.status === 423) {
                    __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                    self.isLoading = false;
                } else {
                    self.isLoading = false;
                    var prop = null;

                    for (var i in self.itemsFormAccount) {
                        self.itemsFormAccount[i].errors = [];
                    }
                    for (i in self.itemsFormPqr) {
                        self.itemsFormPqr[i].errors = [];
                    }
                    for (i in self.itemsFormAttachment) {
                        self.itemsFormAttachment[i].errors = [];
                    }

                    for (i in self.itemsFormAccount) {
                        for (prop in self.data.errors) {
                            if (self.itemsFormAccount[i].name === prop) {
                                self.itemsFormAccount[i].errors = response.body.detail[prop];
                            }
                        }
                    }
                    for (i in self.itemsFormPqr) {
                        for (prop in self.data.errors) {
                            if (self.itemsFormPqr[i].name === prop) {
                                self.itemsFormPqr[i].errors = response.body.detail[prop];
                            }
                        }
                    }
                    for (i in self.itemsFormAttachment) {
                        self.itemsFormAttachment[i].errors = response.body.file;
                    }

                    for (prop in self.data.errors) {
                        __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                            title: 'Se ha presentado un error.',
                            text: self.data.errors[prop],
                            type: 'error',
                            confirmButtonText: 'Aceptar'
                        });
                    }
                }
            });
        },
        registerActivity: function registerActivity() {
            var self = this;
            var values = self.getFormValuesActivity();
            var valuesAttachment = self.getFormValuesActivityAttachment();
            values['pqr'] = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr/' + this.$route.params.id + '/';
            values['status'] = 'PENDING';
            values['section'] = 'EPM';
            values['file'] = null;
            var arrayAttachment = [];
            for (var i = 0; i < valuesAttachment.length; i++) {
                var itemAttachment = {};
                itemAttachment['name'] = valuesAttachment[i].name;
                itemAttachment['attachment'] = valuesAttachment[i].asBase64;
                arrayAttachment.push(itemAttachment);
            }
            if (arrayAttachment.length > 0) {
                values['file'] = arrayAttachment;
            }
            self.$http.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + self.resource[0].resourceActivity, values).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                    title: 'Se actualizó la PQR exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/ConsultPqr');
                self.isLoading = false;
            }, function (response) {
                self.data.errors = response.body;
                self.isLoading = false;
                var prop = null;
                if (self.data.errors.detail) {
                    self.data.errors = JSON.parse(self.data.errors.detail[0].split('\'').join('"'));
                }
                for (var i in self.itemsFormActivity) {
                    self.itemsFormActivity[i].errors = [];
                }
                for (i in self.itemsFormActivity) {
                    for (prop in self.data.errors) {
                        if (self.itemsFormActivity[i].name === prop) {
                            self.itemsFormActivity[i].errors = self.data.errors[prop];
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
        },
        registerActivityProvider: function registerActivityProvider() {
            var self = this;
            var values = self.getFormValuesActivityProvider();
            var valuesAttachment = self.getFormValuesProviderAttachment();
            values['pqr'] = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr/' + this.$route.params.id + '/';
            values['status'] = 'PENDING';
            values['waiting_provider'] = false;
            values['section'] = 'provider';
            values['file'] = null;
            var arrayAttachment = [];
            for (var i = 0; i < valuesAttachment.length; i++) {
                var itemAttachment = {};
                itemAttachment['name'] = valuesAttachment[i].name;
                itemAttachment['attachment'] = valuesAttachment[i].asBase64;
                arrayAttachment.push(itemAttachment);
            }
            if (arrayAttachment.length > 0) {
                values['file'] = arrayAttachment;
            }
            self.$http.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + self.resource[0].resourceActivity, values).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                    title: 'Se actualizó la PQR exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/ConsultPqr');
                self.isLoading = false;
            }, function (response) {
                self.data.errors = response.body;
                self.isLoading = false;
                var prop = null;
                if (self.data.errors.detail) {
                    self.data.errors = JSON.parse(self.data.errors.detail[0].split('\'').join('"'));
                }
                for (var i in self.itemsFormActivityProvider) {
                    self.itemsFormActivityProvider[i].errors = [];
                }
                for (i in self.itemsFormActivityProvider) {
                    for (prop in self.data.errors) {
                        if (self.itemsFormActivityProvider[i].name === prop) {
                            self.itemsFormActivityProvider[i].errors = self.data.errors[prop];
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
        },
        registerActivityClosed: function registerActivityClosed() {
            var self = this;
            var values = self.getFormValuesActivityClosed();
            var valuesAttachment = self.getFormValuesClosedAttachment();
            values['pqr'] = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr/' + this.$route.params.id + '/';
            values['status'] = 'CLOSED';
            values['note'] = 'cierre';
            values['waiting_provider'] = false;
            values['section'] = 'closed';
            values['file'] = null;
            var arrayAttachment = [];
            for (var i = 0; i < valuesAttachment.length; i++) {
                var itemAttachment = {};
                itemAttachment['name'] = valuesAttachment[i].name;
                itemAttachment['attachment'] = valuesAttachment[i].asBase64;
                arrayAttachment.push(itemAttachment);
            }
            if (arrayAttachment.length > 0) {
                values['file'] = arrayAttachment;
            }
            self.$http.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + self.resource[0].resourceActivity, values).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                    title: 'Se realizó el cierre exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/ConsultPqr');
            }, function (response) {
                self.data.errors = response.body;
                self.isLoading = false;
                var prop = null;
                self.data.errors = JSON.parse(self.data.errors.detail[0].split('\'').join('"'));
                for (var i in self.itemsFormActivityClosed) {
                    self.itemsFormActivityClosed[i].errors = [];
                }
                for (i in self.itemsFormActivityClosed) {
                    for (prop in self.data.errors) {
                        if (self.itemsFormActivityClosed[i].name === prop) {
                            self.itemsFormActivityClosed[i].errors = self.data.errors[prop];
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
            self.isLoading = false;
        },
        reassignmentActivityPQR: function reassignmentActivityPQR() {
            var self = this;
            var values = self.getFormValuesReassignment();
            values['pqr'] = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/pqr/' + this.$route.params.id + '/';
            values['status'] = 'SCALED';
            values['section'] = 'reassignment';
            values['reassigned'] = true;
            values['user_from'] = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/user/' + __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('idUser') + '/';
            values['file'] = {};
            self.$http.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + self.resource[0].resourceActivity, values).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                    title: 'Se actualizó la PQR exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                });
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/ConsultPqr');
                self.isLoading = false;
            }, function (response) {
                self.data.errors = response.body;
                self.isLoading = false;
                var prop = null;
                for (var i in self.itemsFormActivityReassignment) {
                    self.itemsFormActivityReassignment[i].errors = [];
                }
                for (i in self.itemsFormActivityReassignment) {
                    for (prop in self.data.errors) {
                        if (self.itemsFormActivityReassignment[i].name === prop) {
                            self.itemsFormActivityReassignment[i].errors = response.body[prop];
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    var message = JSON.parse(self.data.errors.detail[0].split('\'').join('"')).detail[0];
                    __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a({
                        title: 'Se ha presentado un error.',
                        text: message,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
        },
        changeList: function changeList(item) {
            this.$emit('change', item);
        },
        enabledEmail: function enabledEmail(item) {
            this.$emit('changeEmail', item);
        }
    },

    components: {
        'emt-input': __WEBPACK_IMPORTED_MODULE_4__components_input_components_emt_input___default.a,
        'emt-checkbox': __WEBPACK_IMPORTED_MODULE_5__components_input_components_emt_checkbox___default.a,
        'emt-radio': __WEBPACK_IMPORTED_MODULE_6__components_input_components_emt_radio___default.a,
        'emt-select': __WEBPACK_IMPORTED_MODULE_7__components_input_components_emt_select___default.a,
        'emt-textarea': __WEBPACK_IMPORTED_MODULE_8__components_input_components_emt_textarea___default.a,
        'emt-file': __WEBPACK_IMPORTED_MODULE_9__components_input_components_emt_file___default.a,
        'datepicker': __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a
    }
});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-file',
    props: {
        item: Object,
        className: String
    },
    data: function data() {
        return {
            totalSize: 0
        };
    },
    methods: {
        update: function update(event) {
            var self = this;
            var BYTES = 1000000;
            for (var i = 0; i < event.target.files.length; i++) {
                event.target.files[i].sizeMB = Math.round(event.target.files[i].size / BYTES * 100) / 100;
                var errors = [];
                if (event.target.files[i].sizeMB + self.totalSize > self.item.maximumSize) {
                    errors.push('El archivo que intenta cargar excede el peso permitido');
                }
                var fileExtension = event.target.files[i].name.split('.')[event.target.files[i].name.split('.').length - 1];
                if (self.item.extensions.indexOf(fileExtension.toUpperCase()) === -1) {
                    errors.push('La extensión del archivo ' + event.target.files[i].name + ' no es permitida.');
                }
                if (errors.length > 0) {
                    var errorMessage = errors.join('<br>- ');
                    errorMessage = '<div style="text-align: left">- ' + errorMessage + '</div>';
                    __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a({
                        title: 'Favor validar',
                        text: errorMessage,
                        type: 'warning',
                        html: errorMessage,
                        confirmButtonText: 'Aceptar'
                    });
                    return;
                }
                event.target.files[i].asBase64 = null;
                event.target.files[i].ready = 0;
                self.item.value.push(event.target.files[i]);
                self.totalSize = self.totalSize + event.target.files[i].sizeMB;
                self.getBase64(event.target.files[i], self.item.value.length - 1);
            }
        },
        remove: function remove(index) {
            var self = this;
            self.item.value.splice(index, 1);
        },
        click: function click(event) {
            var self = this;
            document.getElementById(self.item.name).click();
        },
        getBase64: function getBase64(file, index) {
            var self = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                var item = self.item.value[index];
                item.asBase64 = reader.result;
                item.ready = 100;
                self.item.value.splice(index, 1, item);
                self.$emit('input', event.target.value);
            };
            reader.onerror = function (error) {
                __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a({
                    title: error,
                    text: '',
                    type: 'danger',
                    confirmButtonText: 'Aceptar'
                });
            };
        }
    },
    mounted: function mounted() {
        var self = this;
        if (self.item.value === null) {
            self.item.value = [];
        }
        self.item.extensions.forEach(function (element, index) {
            self.item.extensions.splice(index, 1, element.toUpperCase());
        }, this);
    }
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control margin-bottom",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.item.name,
      "type": _vm.item.type,
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "disabled": _vm.item.disabled,
      "multiple": "multiple"
    },
    on: {
      "change": _vm.update
    }
  }), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('button', {
    on: {
      "click": _vm.click
    }
  }, [_vm._v("Seleccionar archivos")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n            " + _vm._s(error) + "\n        ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.item.value !== null && _vm.item.value.length > 0) ? _c('div', {
    staticClass: "container-fluid table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('th', [_vm._v("Tamaño")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Tipo de adjunto")]), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('th', [_vm._v("Progreso")]) : _vm._e(), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('th', [_vm._v("Eliminar")]) : _vm._e(), _vm._v(" "), (_vm.item.downloadOnly) ? _c('th', [_vm._v("Descargar")]) : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((_vm.item.value), function(file, key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('td', [_vm._v(_vm._s(file.sizeMB))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.type))]), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('td', [_c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar progress-bar-success",
      style: ({
        width: file.ready + '%'
      }),
      attrs: {
        "role": "progressbar"
      }
    })])]) : _vm._e(), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('td', {
      on: {
        "click": function($event) {
          _vm.remove(key)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash"
    })]) : _vm._e(), _vm._v(" "), (_vm.item.downloadOnly) ? _c('td', [_c('a', {
      attrs: {
        "href": file.link
      }
    }, [_vm._v("enlace")])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    class: _vm.className
  }, [_c('br'), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "file-text"
    }
  }, [_vm._v("Este campo permite adjuntar varios archivos siempre y cuando la suma de todos no superen 20MB, se permitirán las siguientes extensiones: PDF, XLS, XLSX, DOC o DOCX.")])])])
},staticRenderFns: []}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post",
      "action": "",
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.itemsFormActivity), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (typeof(item.visible) === 'undefined' || item.visible === true),
        expression: "typeof(item.visible)==='undefined' || item.visible === true"
      }]
    }, [(item.type === 'text' || item.type === 'number' || item.type === 'password') ? _c('emt-input', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('emt-radio', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('emt-select', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'checkbox') ? _c('emt-checkbox', {
      attrs: {
        "item": item,
        "className": 'col-md-2'
      },
      on: {
        "email": function($event) {
          _vm.enabledEmail(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'textarea') ? _c('emt-textarea', {
      attrs: {
        "item": item,
        "className": 'col-md-10'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "yyyy-MM-dd"
      },
      on: {
        "input": _vm.updateDate
      }
    }) : _vm._e(), _vm._v(" "), ((key + 1) % 3 === 0) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormActivityProvider), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (typeof(item.visible) === 'undefined' || item.visible === true),
        expression: "typeof(item.visible)==='undefined' || item.visible === true"
      }]
    }, [(item.type === 'text' || item.type === 'number' || item.type === 'password') ? _c('emt-input', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('emt-radio', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('emt-select', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'checkbox') ? _c('emt-checkbox', {
      attrs: {
        "item": item,
        "className": 'col-md-2'
      },
      on: {
        "email": function($event) {
          _vm.enabledEmail(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'textarea') ? _c('emt-textarea', {
      attrs: {
        "item": item,
        "className": 'col-md-10'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "yyyy-MM-dd"
      },
      on: {
        "input": _vm.updateDate
      }
    }) : _vm._e(), _vm._v(" "), ((key + 1) % 3 === 0) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormActivityClosed), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (typeof(item.visible) === 'undefined' || item.visible === true),
        expression: "typeof(item.visible)==='undefined' || item.visible === true"
      }]
    }, [(item.type === 'text' || item.type === 'number' || item.type === 'password') ? _c('emt-input', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('emt-radio', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('emt-select', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      },
      on: {
        "change": function($event) {
          _vm.changeList(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'checkbox') ? _c('emt-checkbox', {
      attrs: {
        "item": item,
        "className": 'col-md-2'
      },
      on: {
        "email": function($event) {
          _vm.enabledEmail(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'textarea') ? _c('emt-textarea', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "yyyy-MM-dd"
      },
      on: {
        "input": _vm.updateDate
      }
    }) : _vm._e(), _vm._v(" "), ((key + 1) % 3 === 0) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormAccount), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (typeof(item.visible) === 'undefined' || item.visible === true),
        expression: "typeof(item.visible)==='undefined' || item.visible === true"
      }]
    }, [(item.type === 'text' || item.type === 'number' || item.type === 'password') ? _c('emt-input', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('emt-radio', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('emt-select', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'checkbox') ? _c('emt-checkbox', {
      attrs: {
        "item": item,
        "className": 'col-md-1'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'textarea') ? _c('emt-textarea', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "yyyy-MM-dd"
      },
      on: {
        "input": _vm.updateDate
      }
    }) : _vm._e(), _vm._v(" "), ((key + 1) % 3 === 0) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormPqr), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (typeof(item.visible) === 'undefined' || item.visible === true),
        expression: "typeof(item.visible)==='undefined' || item.visible === true"
      }]
    }, [(item.type === 'text' || item.type === 'number' || item.type === 'password') ? _c('emt-input', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('emt-radio', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('emt-select', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      },
      on: {
        "change": function($event) {
          _vm.changeList(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'checkbox') ? _c('emt-checkbox', {
      attrs: {
        "item": item,
        "className": 'col-md-1'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'textarea') ? _c('emt-textarea', {
      attrs: {
        "item": item,
        "className": 'col-md-12'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "yyyy-MM-dd"
      },
      on: {
        "input": _vm.updateDate
      }
    }) : _vm._e(), _vm._v(" "), ((key + 1) % 3 === 0) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormAttachment), function(item, key) {
    return _c('div', [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (item.type === 'file') ? _c('emt-file', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormActivityAttachment), function(item, key) {
    return _c('div', [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (item.type === 'file') ? _c('emt-file', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormProviderAttachment), function(item, key) {
    return _c('div', [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (item.type === 'file') ? _c('emt-file', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormClosedAttachment), function(item, key) {
    return _c('div', [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (item.type === 'file') ? _c('emt-file', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.itemsFormActivityReassignment), function(item, key) {
    return _c('div', [(item.type === 'text' || item.type === 'number' || item.type === 'password') ? _c('emt-input', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('emt-radio', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('emt-select', {
      attrs: {
        "item": item,
        "className": 'col-md-4'
      },
      on: {
        "change": function($event) {
          _vm.changeList(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'checkbox') ? _c('emt-checkbox', {
      attrs: {
        "item": item,
        "className": 'col-md-1'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'textarea') ? _c('emt-textarea', {
      attrs: {
        "item": item,
        "className": 'col-md-6'
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "yyyy-MM-dd"
      },
      on: {
        "input": _vm.updateDate
      }
    }) : _vm._e(), _vm._v(" "), ((key + 1) % 3 === 0) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [(_vm.itemsFormPqr) ? _c('div', [(this.typeactivity === 'register') ? _c('div', [(!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Guardar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.register
    }
  }) : _c('span', [_vm._v("Cargando...")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.itemsFormActivity) ? _c('div', [(this.typeactivity === 'scaled') ? _c('div', [(!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Guardar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.registerActivity
    }
  }) : _c('span', [_vm._v("Cargando...")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.itemsFormActivityProvider) ? _c('div', [(this.typeactivity === 'waiting_provider') ? _c('div', [(!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Guardar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.registerActivityProvider
    }
  }) : _c('span', [_vm._v("Cargando...")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.itemsFormActivityClosed) ? _c('div', [(this.typeactivity === 'pending' && _vm.Cookies.get('perfil') !== 'Epm') ? _c('div', [(!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Guardar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.registerActivityClosed
    }
  }) : _c('span', [_vm._v("Cargando...")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.itemsFormActivityReassignment) ? _c('div', [(this.typeactivity === 'reassignment') ? _c('div', [(!_vm.isLoading) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Guardar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.reassignmentActivityPQR
    }
  }) : _c('span', [_vm._v("Cargando...")])]) : _vm._e()]) : _vm._e()])], 2)])
},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormPqr": _vm.itemsFormPqr,
      "itemsFormAccount": _vm.itemsFormAccount,
      "itemsFormAttachment": _vm.itemsFormAttachment,
      "updateData": _vm.update,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "change": _vm.changelist
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Registrar PQR")])])
}]}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_form_pqr__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_form_pqr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_form_pqr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);










var isFilial = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('perfil') === 'Consulta filial';
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-register-pqr',
    data: function data() {
        return {
            itemsFormPqr: [{
                'name': 'type',
                'label': 'Tipo PQR',
                'placeholder': 'Seleccione tipo PQR',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'unit',
                'label': 'Unidad',
                'placeholder': 'Seleccione una unidad',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'area',
                'label': 'Área',
                'placeholder': 'Seleccione área',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'reason',
                'label': 'Motivo',
                'placeholder': 'Seleccione motivo',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'subreason',
                'label': 'Submotivo',
                'placeholder': 'Seleccione submotivo',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'user_assigned',
                'label': 'Usuario asignado',
                'placeholder': 'Seleccione usuario',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'channel',
                'label': 'Canal',
                'placeholder': 'Seleccione canal',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'company',
                'label': 'Empresa o filial',
                'placeholder': 'Seleccione empresa',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'process',
                'label': 'Referencia',
                'placeholder': 'Ingrese referencia',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'errors': [],
                'readonly': 'readonly'
            }, {
                'name': 'gender',
                'label': 'Género',
                'placeholder': 'Seleccione el género',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'disabled': 'disabled'
            }, {
                'name': 'note',
                'label': 'Descripción',
                'placeholder': 'Ingrese descripción de la pqr',
                'value': null,
                'maxlength': '5000',
                'type': 'textarea',
                'rows': '1',
                'cols': '1',
                'errors': [],
                'readonly': 'readonly'
            }],
            itemsFormAccount: [{
                'name': 'document',
                'label': 'Documento',
                'placeholder': 'Ingrese Documento',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': [],
                'readonly': 'readonly'
            }, {
                'name': 'name',
                'label': 'Nombre',
                'placeholder': 'Ingrese nombre',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': [],
                'readonly': 'readonly'
            }, {
                'name': 'surname',
                'label': 'Apellido',
                'placeholder': 'Ingrese Apellido',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': [],
                'readonly': 'readonly'
            }, {
                'name': 'phone_number',
                'label': 'Número telefonico',
                'placeholder': 'Ingrese número telefonico',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': [],
                'readonly': 'readonly'
            }, {
                'name': 'cellphone_number',
                'label': 'Celular',
                'placeholder': 'Ingrese Celular',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': [],
                'readonly': 'readonly'
            }, {
                'name': 'email',
                'label': 'Correo electrónico',
                'placeholder': 'Ingrese correo electrónico',
                'maxlength': '50',
                'value': null,
                'type': 'text',
                'errors': [],
                'readonly': 'readonly'
            }],
            itemsFormAttachment: [{
                'name': 'attachment',
                'label': 'Adjunto',
                'placeholder': 'Seleccione Archivo a adjuntar',
                'value': null,
                'type': 'file',
                'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                'maximumSize': 20,
                'downloadOnly': true,
                'errors': []
            }],
            itemsFormActivityAttachment: [{
                'name': 'activityAttachment',
                'label': 'Adjunto',
                'placeholder': 'Seleccione Archivo a adjuntar',
                'value': null,
                'type': 'file',
                'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                'maximumSize': 20,
                'downloadOnly': true,
                'errors': []
            }],
            itemsFormProviderAttachment: [{
                'name': 'providerAttachment',
                'label': 'Adjunto',
                'placeholder': 'Seleccione Archivo a adjuntar',
                'value': null,
                'type': 'file',
                'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                'maximumSize': 20,
                'downloadOnly': true,
                'errors': []
            }],
            itemsFormClosedAttachment: [{
                'name': 'closeAttachment',
                'label': 'Adjunto',
                'placeholder': 'Seleccione Archivo a adjuntar',
                'value': null,
                'type': 'file',
                'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                'maximumSize': 20,
                'downloadOnly': true,
                'errors': []
            }],
            itemsFormActivity: [{
                'name': 'note',
                'label': 'Nota',
                'placeholder': 'Ingrese nota a la pqr',
                'value': null,
                'maxlength': '5000',
                'type': 'textarea',
                'rows': '10',
                'cols': '10',
                'errors': []
            }, {
                'name': 'waiting_provider',
                'label': 'Espera de proveedor',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }, {
                'name': 'attachment',
                'label': 'Adjunto',
                'placeholder': 'Seleccione Archivo a adjuntar',
                'value': null,
                'type': 'file',
                'errors': []
            }, {
                'name': 'user_email',
                'label': 'Email usuario',
                'placeholder': 'Email usuario',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'readonly': true,
                'errors': []
            }, {
                'name': 'email_alternative',
                'label': 'Email usuario alterno',
                'placeholder': 'Email usuario alterno',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'readonly': true,
                'errors': []
            }, {
                'name': 'email_answer',
                'label': 'Enviar Respuesta por email?',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }, {
                'name': 'created_by',
                'label': 'Usuario respuesta',
                'placeholder': 'Usuario respuesta',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'readonly': true,
                'errors': []
            }, {
                'name': 'coming_from',
                'label': 'Procedente',
                'placeholder': 'Seleccione procedencia',
                'value': null,
                'type': 'select',
                'select_options': [{
                    'value': 'YES',
                    'text': 'Sí'
                }, {
                    'value': 'NO',
                    'text': 'No'
                }, {
                    'value': 'ATTENDED',
                    'text': 'Atendido'
                }],
                'errors': []
            }],
            itemsFormActivityProvider: [{
                'name': 'note',
                'label': 'Nota',
                'placeholder': 'Ingrese nota a la pqr',
                'value': null,
                'maxlength': '5000',
                'type': 'textarea',
                'rows': '10',
                'cols': '10',
                'errors': []
            }, {
                'name': 'attachment',
                'label': 'Adjunto',
                'placeholder': 'Seleccione Archivo a adjuntar',
                'value': null,
                'type': 'file',
                'errors': []
            }, {
                'name': 'email_answer',
                'label': 'Enviar Respuesta por email?',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }, {
                'name': 'user_email',
                'label': 'Email usuario',
                'placeholder': 'Email usuario',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'readonly': true,
                'errors': []
            }, {
                'name': 'email_alternative',
                'label': 'Email usuario alterno',
                'placeholder': 'Email usuario alterno',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'readonly': true,
                'errors': []
            }, {
                'name': 'coming_from',
                'label': 'Procedente',
                'placeholder': 'Seleccione procedencia',
                'value': null,
                'type': 'select',
                'select_options': [{
                    'value': 'YES',
                    'text': 'Sí'
                }, {
                    'value': 'NO',
                    'text': 'No'
                }, {
                    'value': 'ATTENDED',
                    'text': 'Atendido'
                }],
                'errors': []
            }, {
                'name': 'created_by',
                'label': 'Usuario respuesta',
                'placeholder': 'Usuario respuesta',
                'value': null,
                'maxlength': '50',
                'type': 'text',
                'readonly': true,
                'errors': []
            }],
            itemsFormActivityClosed: [{
                'name': 'mark',
                'label': 'Calificación',
                'placeholder': 'Ingrese calificación',
                'value': null,
                'type': 'select',
                'select_options': [{
                    'value': 'N/A',
                    'text': 'N/A'
                }, {
                    'value': '1',
                    'text': '1'
                }, {
                    'value': '2',
                    'text': '2'
                }, {
                    'value': '3',
                    'text': '3'
                }, {
                    'value': '4',
                    'text': '4'
                }, {
                    'value': '5',
                    'text': '5'
                }, {
                    'value': '6',
                    'text': '6'
                }, {
                    'value': '7',
                    'text': '7'
                }, {
                    'value': '8',
                    'text': '8'
                }, {
                    'value': '9',
                    'text': '9'
                }, {
                    'value': '10',
                    'text': '10'
                }],
                'errors': []
            }, {
                'name': 'cause',
                'label': 'Justificación',
                'placeholder': 'Ingrese justificación',
                'value': null,
                'maxlength': '100',
                'type': 'text',
                'errors': []
            }, {
                'name': 'close_reason',
                'label': 'Motivo de cierre',
                'placeholder': 'Seleccione motivo de cierre',
                'value': null,
                'type': 'select',
                'select_options': [{
                    'value': 'NO_REASON',
                    'text': 'Sin Especificar'
                }, {
                    'value': 'CONTACTED',
                    'text': 'Contactado'
                }, {
                    'value': 'NO_CONTACTED',
                    'text': 'No Contactado'
                }],
                'errors': []
            }, {
                'name': 'register',
                'label': 'ID',
                'placeholder': 'Ingrese ID',
                'value': null,
                'maxlength': '20',
                'type': 'text',
                'readonly': true,
                'errors': []
            }, {
                'name': 'answer',
                'label': 'Respuesta',
                'placeholder': 'Ingrese respuesta',
                'value': null,
                'maxlength': '5000',
                'type': 'textarea',
                'rows': '1',
                'cols': '1',
                'errors': []
            }],
            itemResource: [{
                'resourceAccount': '/account/',
                'resourcePqr': '/pqr/',
                'resourceAttachment': '/attachment/',
                'resourceActivity': '/activity/',
                'resourceActivityFullData': '/activity_full_data/'
            }],
            update: false,
            pqrDisplay: true,
            pqrDisplayActivity: true,
            pqrDisplayActivityProvider: true,
            pqrDisplayActivityClosed: true,
            typeactivity: '',
            emailUserPqr: '',
            activityProvider: false
        };
    },
    methods: {
        enabledForms: function enabledForms(Activity) {
            var self = this;
            if (isFilial === true) {
                for (var form in this.itemsFormActivity) {
                    if (this.itemsFormActivity[form]['type'] === 'checkbox' || this.itemsFormActivity[form]['type'] === 'file' || this.itemsFormActivity[form]['type'] === 'select') {
                        this.itemsFormActivity[form]['disabled'] = 'disabled';
                    } else {
                        this.itemsFormActivity[form]['readonly'] = 'readonly';
                    }
                }
                for (form in this.itemsFormActivityProvider) {
                    if (this.itemsFormActivityProvider[form]['type'] === 'checkbox' || this.itemsFormActivityProvider[form]['type'] === 'file' || this.itemsFormActivityProvider[form]['type'] === 'select') {
                        this.itemsFormActivityProvider[form]['disabled'] = 'disabled';
                    } else {
                        this.itemsFormActivityProvider[form]['readonly'] = 'readonly';
                    }
                }
                for (form in this.itemsFormActivityClosed) {
                    if (this.itemsFormActivityClosed[form]['type'] === 'checkbox' || this.itemsFormActivityClosed[form]['type'] === 'file' || this.itemsFormActivityClosed[form]['type'] === 'select') {
                        this.itemsFormActivityClosed[form]['disabled'] = 'disabled';
                    } else {
                        this.itemsFormActivityClosed[form]['readonly'] = 'readonly';
                    }
                }
            } else {
                if (Activity === 'closed') {
                    for (form in this.itemsFormActivity) {
                        if (this.itemsFormActivity[form]['name'] === 'waiting_provider') {
                            if (this.itemsFormActivity[form]['value'] === true) {
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', false);
                            } else {
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', true);
                            }
                        }
                        if (this.itemsFormActivity[form]['type'] === 'checkbox' || this.itemsFormActivity[form]['type'] === 'file' || this.itemsFormActivity[form]['type'] === 'select') {
                            self.$set(this.itemsFormActivity[form], 'disabled', 'disabled');
                        } else {
                            self.$set(this.itemsFormActivity[form], 'readonly', 'readonly');
                        }
                    }
                    for (form in this.itemsFormActivityProvider) {
                        if (this.itemsFormActivityProvider[form]['type'] === 'checkbox' || this.itemsFormActivityProvider[form]['type'] === 'file' || this.itemsFormActivityProvider[form]['type'] === 'select') {
                            self.$set(this.itemsFormActivityProvider[form], 'disabled', 'disabled');
                        } else {
                            self.$set(this.itemsFormActivityProvider[form], 'readonly', 'readonly');
                        }
                    }
                    for (form in this.itemsFormActivityClosed) {
                        if (this.itemsFormActivityClosed[form]['type'] === 'checkbox' || this.itemsFormActivityClosed[form]['type'] === 'file' || this.itemsFormActivityClosed[form]['type'] === 'select') {
                            self.$set(this.itemsFormActivityClosed[form], 'disabled', 'disabled');
                        } else {
                            self.$set(this.itemsFormActivityClosed[form], 'readonly', 'readonly');
                        }
                    }
                } else if (Activity === 'waiting_provider') {
                    for (var formProvider in this.itemsFormActivity) {
                        if (this.itemsFormActivity[formProvider]['name'] === 'waiting_provider') {
                            if (this.itemsFormActivity[formProvider]['value'] === true) {
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', false);
                            } else {
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', true);
                            }
                        }
                        if (this.itemsFormActivity[formProvider]['type'] === 'checkbox' || this.itemsFormActivity[formProvider]['type'] === 'file' || this.itemsFormActivity[formProvider]['type'] === 'select') {
                            self.$set(this.itemsFormActivity[formProvider], 'disabled', 'disabled');
                        } else {
                            self.$set(this.itemsFormActivity[formProvider], 'readonly', 'readonly');
                        }
                    }
                } else if (Activity === 'pending') {
                    for (var formPending in this.itemsFormActivity) {
                        if (this.itemsFormActivity[formPending]['name'] === 'waiting_provider') {
                            if (this.itemsFormActivity[formPending]['value'] === true) {
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(this.itemsFormActivity, 'name', 'user_email'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(this.itemsFormActivity, 'name', 'email_alternative'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(this.itemsFormActivity, 'name', 'coming_from'), 'visible', false);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(this.itemsFormActivity, 'name', 'email_answer'), 'visible', false);
                            } else {
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(this.itemsFormActivity, 'name', 'user_email'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(this.itemsFormActivity, 'name', 'email_alternative'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(this.itemsFormActivity, 'name', 'coming_from'), 'visible', true);
                                self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(this.itemsFormActivity, 'name', 'email_answer'), 'visible', true);
                            }
                        }
                        if (this.itemsFormActivity[formPending]['type'] === 'checkbox' || this.itemsFormActivity[formPending]['type'] === 'file' || this.itemsFormActivity[formPending]['type'] === 'select') {
                            self.$set(this.itemsFormActivity[formPending], 'disabled', 'disabled');
                        } else {
                            self.$set(this.itemsFormActivity[formPending], 'readonly', 'readonly');
                        }
                    }
                    for (formPending in this.itemsFormActivityProvider) {
                        if (this.itemsFormActivityProvider[formPending]['type'] === 'checkbox' || this.itemsFormActivityProvider[formPending]['type'] === 'file' || this.itemsFormActivityProvider[formPending]['type'] === 'select') {
                            self.$set(this.itemsFormActivityProvider[formPending], 'disabled', 'disabled');
                        } else {
                            self.$set(this.itemsFormActivityProvider[formPending], 'readonly', 'readonly');
                        }
                    }
                }
            }
        },

        getDataAccount: function getDataAccount(url) {
            var self = this;
            url = url + this.$route.params.id + '/';
            self.$http.get(url).then(function (response) {
                url = response.body.account;
                self.$http.get(url).then(function (response) {
                    self.setValueAccount(response.body);
                });
            });
        },
        reasignados: function reasignados(url) {
            var self = this;
            url = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + self.itemResource[0].resourceActivityFullData + '?reassigned=true&pqr=' + this.$route.params.id;
            self.$http.get(url).then(function (response) {
                var body = response.body.results;
                if (body.length > 0) {
                    var list = '<ul>';
                    for (var i in body) {
                        if (body[i].user_assigned) {
                            list = list + '<li><b>Usuario: </b>' + body[i].created_by + ' <b>Fecha: </b>' + String(body[i].created_at).replace('T', ' ') + '</li>';
                        }
                    }
                    list = list + '</ul>';
                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a({
                        title: 'Usuarios que reasignaron la pqr',
                        text: '',
                        type: 'info',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'No',
                        html: list
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a({
                        title: '',
                        text: '',
                        type: 'info',
                        confirmButtonText: 'Aceptar',
                        html: 'Esta pqr no tiene reasignaciones'
                    });
                }
            });
        },

        setValueAccount: function setValueAccount(value) {
            for (var form in this.itemsFormAccount) {
                if (this.itemsFormAccount[form].name === 'email') {
                    this.emailUserPqr = value[this.itemsFormAccount[form].name];
                }
                this.itemsFormAccount[form].value = value[this.itemsFormAccount[form].name];
            }
        },

        getDataPqr: function getDataPqr(url) {
            url = url + this.$route.params.id + '/';
            var self = this;
            self.$http.get(url).then(function (response) {
                if (response.body['status'] === 'PENDING') {
                    self.typeactivity = 'pending';
                    self.itemsFormClosedAttachment[0].downloadOnly = false;
                    if (response.body['waiting_provider']) {
                        self.typeactivity = 'waiting_provider';
                        self.itemsFormProviderAttachment[0].downloadOnly = false;
                        self.itemsFormClosedAttachment[0].downloadOnly = true;
                        self.activityProvider = true;
                    }
                } else if (response.body['status'] === 'CLOSED') {
                    self.typeactivity = 'closed';
                } else if (response.body['status'] === 'SCALED') {
                    self.typeactivity = 'scaled';
                    self.itemsFormActivityAttachment[0].downloadOnly = false;
                }
                if (self.typeactivity === 'closed') {
                    self.setValuePqrClosed(response.body);
                }
                self.setValuePqr(response.body);
                self.enabledForms(self.typeactivity, self.activityProvider);
            }, function (response) {});
        },

        setValuePqr: function setValuePqr(value) {
            for (var form in this.itemsFormPqr) {
                if (this.itemsFormPqr[form].type === 'select') {
                    this.itemsFormPqr[form].value = value[this.itemsFormPqr[form].name];
                } else {
                    this.itemsFormPqr[form].value = value[this.itemsFormPqr[form].name];
                }
            }
        },
        getDataAttachment: function getDataAttachment(urlAttachment, urlContentType, urlDownload) {
            var self = this;
            urlContentType = urlContentType + '?model=pqr';
            self.$http.get(urlContentType).then(function (response) {
                urlAttachment = urlAttachment + '?content_type=' + response.body.results[0].id + '&object_id=' + this.$route.params.id;
                self.$http.get(urlAttachment).then(function (response) {
                    var files = response.body.results;
                    self.setValueAttachment(files, urlDownload);
                }, function (response) {});
            }, function (response) {});
        },
        setValueAttachment: function setValueAttachment(files, urlDownload) {
            var self = this;
            self.itemsFormAttachment[0].value = [];
            for (var file in files) {
                var fileInput = {};
                fileInput.name = files[file].complete_filename;
                fileInput.type = files[file].file_mime_type;
                fileInput.id = files[file].id;
                fileInput.link = urlDownload + '?uuid=' + files[file].uuid;
                self.itemsFormAttachment[0].value.push(fileInput);
            }
        },
        getDataProviderAttachment: function getDataProviderAttachment(urlAttachment, urlContentType, urlDownload, id) {
            var self = this;
            urlContentType = urlContentType + '?model=activity';
            self.$http.get(urlContentType).then(function (response) {
                urlAttachment = urlAttachment + '?content_type=' + response.body.results[0].id + '&object_id=' + id;
                self.$http.get(urlAttachment).then(function (response) {
                    var files = response.body.results;
                    self.setValueProviderAttachment(files, urlDownload);
                }, function (response) {});
            }, function (response) {});
        },
        setValueProviderAttachment: function setValueProviderAttachment(files, urlDownload) {
            var self = this;
            self.itemsFormProviderAttachment[0].value = [];
            for (var file in files) {
                var fileInput = {};
                fileInput.name = files[file].complete_filename;
                fileInput.type = files[file].file_mime_type;
                fileInput.id = files[file].id;
                fileInput.link = urlDownload + '?uuid=' + files[file].uuid;
                self.itemsFormProviderAttachment[0].value.push(fileInput);
            }
        },
        getDataActivityAttachment: function getDataActivityAttachment(urlAttachment, urlContentType, urlDownload, id) {
            var self = this;
            urlContentType = urlContentType + '?model=activity';
            self.$http.get(urlContentType).then(function (response) {
                urlAttachment = urlAttachment + '?content_type=' + response.body.results[0].id + '&object_id=' + id;
                self.$http.get(urlAttachment).then(function (response) {
                    var files = response.body.results;
                    self.setValueActivityAttachment(files, urlDownload);
                }, function (response) {});
            }, function (response) {});
        },
        setValueActivityAttachment: function setValueActivityAttachment(files, urlDownload) {
            var self = this;
            self.itemsFormActivityAttachment[0].value = [];
            for (var file in files) {
                var fileInput = {};
                fileInput.name = files[file].complete_filename;
                fileInput.type = files[file].file_mime_type;
                fileInput.id = files[file].id;
                fileInput.link = urlDownload + '?uuid=' + files[file].uuid;
                self.itemsFormActivityAttachment[0].value.push(fileInput);
            }
        },
        getDataClosedAttachment: function getDataClosedAttachment(urlAttachment, urlContentType, urlDownload, id) {
            var self = this;
            urlContentType = urlContentType + '?model=activity';
            self.$http.get(urlContentType).then(function (response) {
                urlAttachment = urlAttachment + '?content_type=' + response.body.results[0].id + '&object_id=' + id;
                self.$http.get(urlAttachment).then(function (response) {
                    var files = response.body.results;
                    self.setValueClosedAttachment(files, urlDownload);
                }, function (response) {});
            }, function (response) {});
        },
        setValueClosedAttachment: function setValueClosedAttachment(files, urlDownload) {
            var self = this;
            self.itemsFormClosedAttachment[0].value = [];
            for (var file in files) {
                var fileInput = {};
                fileInput.name = files[file].complete_filename;
                fileInput.type = files[file].file_mime_type;
                fileInput.id = files[file].id;
                fileInput.link = urlDownload + '?uuid=' + files[file].uuid;
                self.itemsFormClosedAttachment[0].value.push(fileInput);
            }
        },
        setValuePqrClosed: function setValuePqrClosed(value) {
            for (var form in this.itemsFormActivityClosed) {
                if (this.itemsFormActivityClosed[form].type === 'select') {
                    this.itemsFormActivityClosed[form].value = value[this.itemsFormActivityClosed[form].name];
                } else {
                    this.itemsFormActivityClosed[form].value = value[this.itemsFormActivityClosed[form].name];
                }
            }
        },

        getDataActivity: function getDataActivity(url) {
            url = url + '?pqr=' + this.$route.params.id;
            var self = this;
            self.$http.get(url).then(function (response) {
                for (var activity in response.body.results) {
                    if (response.body.results[activity].section === 'EPM') {
                        self.getDataActivityAttachment(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/attachment/', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/content_type/', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].download, response.body.results[activity].id);
                        self.setValueActivity(response.body.results[activity]);
                    }
                    if (response.body.results[activity].section === 'provider') {
                        self.activityProvider = true;
                        self.getDataProviderAttachment(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/attachment/', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/content_type/', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].download, response.body.results[activity].id);
                        self.setValueActivityProvider(response.body.results[activity]);
                    }
                    if (response.body.results[activity].section === 'closed') {
                        self.getDataClosedAttachment(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/attachment/', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/content_type/', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].download, response.body.results[activity].id);
                        self.setValuePqrClosed(response.body.results[activity]);
                    }
                }
            }, function (response) {});
        },

        setValueActivity: function setValueActivity(value) {
            for (var form in this.itemsFormActivity) {
                if (this.itemsFormActivity[form].type === 'select') {
                    this.itemsFormActivity[form].value = value[this.itemsFormActivity[form].name];
                } else {
                    this.itemsFormActivity[form].value = value[this.itemsFormActivity[form].name];
                }
            }
        },
        setValueActivityProvider: function setValueActivityProvider(value) {
            for (var form in this.itemsFormActivityProvider) {
                if (this.itemsFormActivityProvider[form].type === 'select') {
                    this.itemsFormActivityProvider[form].value = value[this.itemsFormActivityProvider[form].name];
                } else {
                    this.itemsFormActivityProvider[form].value = value[this.itemsFormActivityProvider[form].name];
                }
            }
        },

        getType: function getType() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/pqr_type/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[0].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getUnits: function getUnits() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/unit/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getArea: function getArea() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/area/?nopaginate=1&ordering=name').then(function (response) {
                self.itemsFormPqr[2].select_options = [];
                for (var data in response.body) {
                    self.itemsFormPqr[2].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getReason: function getReason() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/reason/?nopaginate=1&ordering=name').then(function (response) {
                self.itemsFormPqr[3].select_options = [];
                for (var data in response.body) {
                    self.itemsFormPqr[3].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getSubreason: function getSubreason() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/subreason/?nopaginate=1&ordering=name').then(function (response) {
                self.itemsFormPqr[4].select_options = [];
                for (var data in response.body) {
                    self.itemsFormPqr[4].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getUserAssigned: function getUserAssigned() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/user/?nopaginate=1&ordering=name').then(function (response) {
                self.itemsFormPqr[5].select_options = [];
                for (var data in response.body) {
                    self.itemsFormPqr[5].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getChannel: function getChannel() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/channel/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[6].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },

        getCompany: function getCompany() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/company/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[7].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },
        changelist: function changelist(item) {
            var self = this;
            if (item.name === 'close_reason') {
                if (item.value === 'CONTACTED') {
                    self.itemsFormActivityClosed[3].readonly = false;
                } else {
                    self.itemsFormActivityClosed[3].value = null;
                    self.itemsFormActivityClosed[3].readonly = true;
                }
            }
        },
        enabledEmails: function enabledEmails(item) {
            var self = this;
            if (item.value === true) {
                self.itemsFormActivityClosed[6].value = this.emailUserPqr;
                self.itemsFormActivityClosed[6].readonly = false;
                self.itemsFormActivityClosed[7].readonly = false;
            } else {
                self.itemsFormActivityClosed[6].readonly = true;
                self.itemsFormActivityClosed[6].value = null;
                self.itemsFormActivityClosed[7].value = null;
                self.itemsFormActivityClosed[7].readonly = true;
            }
        },
        enabledEmailsActivity: function enabledEmailsActivity(item) {
            var self = this;
            if (item.name === 'waiting_provider') {
                if (item.value === true) {
                    self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', false);
                    self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', false);
                    self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', false);
                    self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', false);
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_answer').value = false;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email').readonly = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from').readonly = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative').readonly = true;
                } else {
                    self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', true);
                    self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', true);
                    self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', true);
                    self.$set(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', true);
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_answer').value = false;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email').readonly = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'coming_from').readonly = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative').readonly = true;
                }
            }
            if (item.name === 'email_answer') {
                if (item.value === true) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email').value = this.emailUserPqr;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email').readonly = false;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative').readonly = false;
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'user_email').readonly = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivity, 'name', 'email_alternative').readonly = true;
                }
            }
        },
        enabledEmailsActivityProvider: function enabledEmailsActivityProvider(item) {
            var self = this;
            if (item.name === 'email_answer') {
                if (item.value === true) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivityProvider, 'name', 'user_email').value = this.emailUserPqr;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivityProvider, 'name', 'user_email').readonly = false;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivityProvider, 'name', 'email_alternative').readonly = false;
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivityProvider, 'name', 'user_email').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivityProvider, 'name', 'user_email').readonly = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivityProvider, 'name', 'email_alternative').value = null;
                    __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Arrays */].getItemBy(self.itemsFormActivityProvider, 'name', 'email_alternative').readonly = true;
                }
            }
        },

        getGender: function getGender() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/gender/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[9].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_3__generic__["a" /* default */].setToken();
        this.getType();
        this.getUnits();
        this.getArea();
        this.getReason();
        this.getSubreason();
        this.getUserAssigned();
        this.getChannel();
        this.getCompany();
        this.getGender();
    },
    mounted: function mounted() {
        if (this.typeactivity !== 'register') {
            this.getDataAccount(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/pqr/');
            this.getDataActivity(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/activity_full_data/');
            this.getDataPqr(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/pqr/');
            this.getDataAttachment(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/attachment/', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/content_type/', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].download);
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_5__components_emt_form_pqr___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_6__components_emt_loading___default.a
    }
});

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [(this.typeactivity === 'scaled') ? _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    attrs: {
      "to": '/Reassignment/' + this.$route.params.id
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Reasignar PQR")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("PQR " + _vm._s(this.$route.params.id))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pqr_form"
    }
  }, [_c('div', {
    staticClass: "panel-group pqr_panel",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.pqrDisplay = !_vm.pqrDisplay
      }
    }
  }, [_vm._v("Creación de PQR")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pqrDisplay),
      expression: "pqrDisplay"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormPqr": _vm.itemsFormPqr,
      "itemsFormAccount": _vm.itemsFormAccount,
      "itemsFormAttachment": _vm.itemsFormAttachment,
      "updateData": _vm.update,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn-login"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btningresar",
      "name": "btningresar"
    },
    on: {
      "click": function($event) {
        _vm.reasignados()
      }
    }
  }, [_vm._v("Ver reasignaciones")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel-group pqr_panel pqr_panel",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.pqrDisplayActivity = !_vm.pqrDisplayActivity
      }
    }
  }, [_vm._v("Respuesta de EPM")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pqrDisplayActivity),
      expression: "pqrDisplayActivity"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormActivity": _vm.itemsFormActivity,
      "itemsFormActivityAttachment": _vm.itemsFormActivityAttachment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "changeEmail": _vm.enabledEmailsActivity
    }
  })], 1)])])]), _vm._v(" "), (this.activityProvider === 'waiting_provider' || this.activityProvider == true) ? _c('div', {
    staticClass: "panel-group pqr_panel pqr_panel",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.pqrDisplayActivityProvider = !_vm.pqrDisplayActivityProvider
      }
    }
  }, [_vm._v("Respuesta de proveedor")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pqrDisplayActivityProvider),
      expression: "pqrDisplayActivityProvider"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormActivityProvider": _vm.itemsFormActivityProvider,
      "itemsFormProviderAttachment": _vm.itemsFormProviderAttachment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "changeEmail": _vm.enabledEmailsActivityProvider
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (this.typeactivity === 'pending' || this.typeactivity === 'closed') ? _c('div', {
    staticClass: "panel-group pqr_panel pqr_panel",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.pqrDisplayActivityClosed = !_vm.pqrDisplayActivityClosed
      }
    }
  }, [_vm._v("Cierre de PQR")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pqrDisplayActivityClosed),
      expression: "pqrDisplayActivityClosed"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormActivityClosed": _vm.itemsFormActivityClosed,
      "itemsFormClosedAttachment": _vm.itemsFormClosedAttachment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "change": _vm.changelist
    }
  })], 1)])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_form_pqr__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_form_pqr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_form_pqr__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-reassignment',
    data: function data() {
        return {
            itemsFormActivityReassignment: [{
                'name': 'note',
                'label': 'Nota',
                'placeholder': 'Ingrese nota para la redirección',
                'value': null,
                'maxlength': '5000',
                'type': 'textarea',
                'rows': '10',
                'cols': '10',
                'errors': []
            }, {
                'name': 'unit',
                'label': 'Unidad',
                'placeholder': 'Seleccione una unidad',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'dependencies': ['area']
            }, {
                'name': 'area',
                'label': 'Área',
                'placeholder': 'Seleccione área',
                'value': null,
                'type': 'select',
                'select_options': [],
                'errors': [],
                'dependencies': []
            }],
            itemResource: [{
                'resourcePqr': '/pqr/',
                'resourceAttachment': '/attachment/',
                'resourceActivity': '/activity/'
            }],
            typeactivity: 'reassignment'
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_4__generic__["a" /* default */].setToken();
        this.getUnit();
    },
    methods: {
        changelist: function changelist(item) {
            var itemSelected = __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* Arrays */].getItemBy(item.select_options, 'value', item.value);
            itemSelected = itemSelected === null || itemSelected === undefined ? { id: '', value: '' } : itemSelected;
            var callbackObject = {};
            switch (item.name) {
                case 'unit':
                    var id = (typeof itemSelected === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default.a(itemSelected)) !== undefined ? itemSelected.id : '';
                    callbackObject = {
                        functions: [this.getArea],
                        arguments: [id]
                    };
                    __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* Arrays */].clearSelect(this.itemsFormActivityReassignment, item, callbackObject);
                    break;
            }
        },
        getUnit: function getUnit(value) {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormActivityReassignment[1].value = '';
                    self.itemsFormActivityReassignment[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name,
                        id: response.body[data].id
                    });
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
            });
        },
        getArea: function getArea(value) {
            try {
                var self = this;
                if (self.itemsFormActivityReassignment[1].value !== undefined && self.itemsFormActivityReassignment[1].value !== null && value !== null && value !== undefined && value !== '') {
                    var id = value;
                    self.$http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].api + '/area/?nopaginate=1&is_active=true&ordering=name&unit=' + id).then(function (response) {
                        for (var data in response.body) {
                            self.itemsFormActivityReassignment[2].select_options.push({
                                value: response.body[data].url,
                                text: response.body[data].name,
                                id: response.body[data].id,
                                responsible: response.body[data].responsible
                            });
                        }
                    }, function (response) {
                        console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO');
                    });
                }
            } catch (e) {
                self.itemsFormActivityReassignment[2].select_options.push({
                    value: '',
                    text: '',
                    id: '',
                    responsible: ''
                });
            }
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_6__components_emt_form_pqr___default.a
    }
});

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "reassignment-form",
    attrs: {
      "itemsFormActivityReassignment": _vm.itemsFormActivityReassignment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "change": _vm.changelist
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Reasignar PQR")])])
}]}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-change-password',
    data: function data() {
        return {
            itemsFormActivityReassignment: [{
                'name': 'password',
                'label': 'Contraseña nueva',
                'placeholder': 'Ingrese nueva contraseña',
                'value': null,
                'maxlength': '50',
                'type': 'password',
                'errors': []
            }, {
                'name': 'password_two',
                'label': 'Confirme su nueva contraseña',
                'placeholder': 'Confirme su nueva contraseña',
                'value': null,
                'maxlength': '50',
                'type': 'password',
                'errors': []
            }],
            itemResource: [{
                'resourcePassword': '/change_password/'
            }],
            typeactivity: 'changePassword',
            user: ''
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        this.getUser();
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
    },
    methods: {
        getUser: function getUser() {
            var self = this;
            self.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/user/?nopaginate=1&id=' + self.$route.params.id).then(function (response) {
                self.user = response.body[0].username;
            }, function (response) {
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a({
                    title: 'Se presento un problema',
                    text: '',
                    type: 'danger',
                    confirmButtonText: 'Aceptar'
                });
            });
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form_register_user___default.a
    }
});

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Cambiar contraseña a: " + _vm._s(this.user))])]), _vm._v(" "), _c('emt-form', {
    ref: "reassignment-form",
    attrs: {
      "items": _vm.itemsFormActivityReassignment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  "data-v-479189bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datetimepicker__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-export',
    data: function data() {
        return {
            items: [{
                'name': 'date_start',
                'label': 'Fecha inicio',
                'class': 'form-control txb-calendar',
                'divclass': 'col-md-3',
                'placeholder': 'Ingrese fecha inicio',
                'value': null,
                'maxlength': '50',
                'type': 'date',
                'errors': []
            }, {
                'name': 'date_end',
                'label': 'Fecha Fin',
                'class': 'form-control txb-calendar',
                'divclass': 'col-md-3',
                'placeholder': 'Ingrese fecha fin',
                'value': null,
                'maxlength': '50',
                'type': 'date',
                'errors': []
            }],
            config: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */],
            update: false
        };
    },
    methods: {
        getFormValues: function getFormValues() {
            var self = this;
            var formValues = {};
            for (var i = 0; i < self.items.length; i++) {
                formValues[self.items[i].name] = self.items[i].value !== null ? self.items[i].value : null;
            }
            return formValues;
        },
        updateDate: function updateDate(value) {
            for (var item in this.items) {
                try {
                    this.items[item].value = this.items[item].value;
                } catch (e) {}
            }
        },
        exportpqr: function exportpqr() {
            var values = this.getFormValues();
            if (values['date_end'] === null || values['date_start'] === null) {
                for (var item in this.items) {
                    if (this.items[item].name === 'date_start' && this.items[item].value === null) {
                        this.items[item].errors = ['Debe seleccionar la fecha inicio'];
                    }
                    if (this.items[item].name === 'date_end' && this.items[item].value === null) {
                        this.items[item].errors = ['Debe seleccionar la fecha fin'];
                    }
                }
                return;
            }
            var dateEnd = new Date(values['date_end']);
            var dateStart = new Date(values['date_start']);
            if (dateStart > dateEnd) {
                this.items[0].errors = [];
                this.items[1].errors = [];
                for (var j in this.items) {
                    if (this.items[j].name === 'date_end') {
                        this.items[j].errors = ['La fecha fin no debe ser menor a la fecha de inicio'];
                    }
                }
                return;
            }

            var oneDay = 1000 * 60 * 60 * 24;

            var dateDStart = dateStart.getTime();
            var dateDEnd = dateEnd.getTime();

            var differenceDates = Math.abs(dateDStart - dateDEnd);
            if (Math.round(differenceDates / oneDay) > 31) {
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a({
                    title: '',
                    text: 'El rango de fecha no puede superar los 31 días.',
                    type: 'error',
                    confirmButtonText: 'Aceptar'
                });
                return;
            }
            this.$http.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api + '/export/', values, { responseType: 'arraybuffer' }).then(function (response) {
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Pqrs.xls');
                document.body.appendChild(link);
                link.click();
                this.items[0].errors = [];
                this.items[1].errors = [];
            }, function (response) {
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a({
                    title: '',
                    text: response.body.error,
                    type: 'error',
                    confirmButtonText: 'Aceptar'
                });
                var date = new Date(Date.now());
                this.items[0].value = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate() + ' 00:00:00';
                this.items[1].value = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate() + ' 23:59:59';
                this.items[0].errors = [];
                this.items[1].errors = [];
            });
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
            return;
        }
        var date = new Date(Date.now());
        this.items[0].value = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate() + ' 00:00:00';
        this.items[1].value = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate() + ' 23:59:59';
        __WEBPACK_IMPORTED_MODULE_3__generic__["a" /* default */].setToken();
    },
    components: {
        'datepicker': __WEBPACK_IMPORTED_MODULE_0_vuejs_datetimepicker___default.a
    }
});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  "data-v-76dde8c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _start_of_month = __webpack_require__(210);

var _start_of_month2 = _interopRequireDefault(_start_of_month);

var _end_of_month = __webpack_require__(212);

var _end_of_month2 = _interopRequireDefault(_end_of_month);

var _each_day = __webpack_require__(213);

var _each_day2 = _interopRequireDefault(_each_day);

var _get_day = __webpack_require__(214);

var _get_day2 = _interopRequireDefault(_get_day);

var _format = __webpack_require__(215);

var _format2 = _interopRequireDefault(_format);

var _start_of_day = __webpack_require__(60);

var _start_of_day2 = _interopRequireDefault(_start_of_day);

var _is_equal = __webpack_require__(227);

var _is_equal2 = _interopRequireDefault(_is_equal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var AM = 'AM';
var PM = 'PM';
exports.default = {
  name: 'datetime-picker',
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD h:i:s'
    },
    name: {
      type: String
    },
    width: {
      type: String
    },
    value: {
      type: String,
      default: new Date()
    },
    firstDayOfWeek: {
      default: 0,
      validator: function validator(value) {
        try {
          var val = parseInt(value, 10);
          return val >= 0 && val <= 1;
        } catch (e) {
          console.warn(e.message);
          return false;
        }
      },
      message: 'Only 0 (Sunday) and 1 (Monday) are supported.'
    }
  },
  data: function data() {
    return {
      date: this.value,
      hideCal: true,
      activePort: null,
      timeStamp: new Date(),
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: [],
      monthIndex: 0,
      hourIndex: 0,
      minuteIndex: 0,
      year: 2017,
      portsHolder: [],
      minute: '00',
      hour: '01',
      day: 1,
      minuteSelectorVisible: false,
      hourSelectorVisible: false,
      period: AM
    };
  },

  methods: {
    leftMonth: function leftMonth() {
      var index = this.months.indexOf(this.month);
      if (index === 0) {
        this.monthIndex = 11;
      } else {
        this.monthIndex = index - 1;
      }
      this.updateCalendar();
    },
    rightMonth: function rightMonth() {
      var index = this.months.indexOf(this.month);
      if (index === 11) {
        this.monthIndex = 0;
      } else {
        this.monthIndex = index + 1;
      }
      this.updateCalendar();
    },
    rightYear: function rightYear() {
      this.year++;
      this.updateCalendar();
    },
    leftYear: function leftYear() {
      this.year--;
      this.updateCalendar();
    },
    updateActivePortFromWeek: function updateActivePortFromWeek(week, weekIndex) {
      var currentActive = (0, _start_of_day2.default)(this.timeStamp);
      var index = week.findIndex(function (day) {
        return (0, _is_equal2.default)(currentActive, day);
      });
      if (index !== -1) {
        this.activePort = weekIndex * 7 + index;
      }
    },
    updateCalendar: function updateCalendar() {
      var _this = this;

      var date = new Date(this.year, this.monthIndex, 1, 0, 0, 0);
      var weeks = [];
      var week = null;
      var weekDays = new Array(7);
      // let index = 0;
      this.activePort = null;
      (0, _each_day2.default)(date, (0, _end_of_month2.default)(date)).forEach(function (day) {
        var weekday = (0, _get_day2.default)(day);
        if (weekday === _this.normalizedFirstDayOfWeek) {
          if (week) {
            weeks.push(week);
            // Add those days that were not part of the month to the index
            // index += week.filter(d => d === null).length;
            _this.updateActivePortFromWeek(weekDays, weeks.length - 1);
            weekDays = new Array(7);
          }
          week = new Array(7);
        } else if (week === null) {
          week = new Array(7);
        }
        var idx = (weekday - _this.normalizedFirstDayOfWeek + 7) % 7;
        week[idx] = (0, _format2.default)(day, 'DD');
        weekDays[idx] = day;
      });
      if (week && week.some(function (n) {
        return n;
      })) {
        weeks.push(week);
        this.updateActivePortFromWeek(weekDays, weeks.length - 1);
      }
      this.weeks = weeks;
    },
    setDay: function setDay(index, port) {
      if (port) {
        this.activePort = index;
        this.day = parseInt(port, 10);
        this.timeStamp = new Date(this.year, this.monthIndex, this.day);
      }
    },
    setMinute: function setMinute(index, closeAfterSet) {
      this.minuteIndex = index;
      this.minute = this.minutes[index];
      if (closeAfterSet) {
        this.minuteSelectorVisible = false;
      }
    },
    setHour: function setHour(index, closeAfterSet) {
      this.hourIndex = index;
      this.hour = this.hours[index];
      if (closeAfterSet) {
        this.hourSelectorVisible = false;
      }
    },
    showHourSelector: function showHourSelector() {
      this.hourSelectorVisible = true;
      this.minuteSelectorVisible = false;
    },
    showMinuteSelector: function showMinuteSelector() {
      this.minuteSelectorVisible = true;
      this.hourSelectorVisible = false;
    },
    keyIsDown: function keyIsDown(event) {
      var key = event.which || event.keycode;
      if (key === 38) {
        if (this.minuteSelectorVisible && this.minuteIndex > 0) {
          this.setMinute(this.minuteIndex - 1, false);
          this.scrollTopMinute();
        } else if (this.hourSelectorVisible && this.hourIndex > 0) {
          this.setHour(this.hourIndex - 1, false);
          this.scrollTopHour();
        }
      } else if (key === 40) {
        if (this.minuteSelectorVisible && this.minuteIndex < this.minutes.length - 1) {
          this.setMinute(this.minuteIndex + 1, false);
          this.scrollTopMinute();
        } else if (this.hourSelectorVisible && this.hourIndex < this.hours.length - 1) {
          this.setHour(this.hourIndex + 1, false);
          this.scrollTopHour();
        }
      } else if (key === 13) {
        this.minuteSelectorVisible = false;
        this.hourSelectorVisible = false;
      }
      if (this.minuteSelectorVisible || this.hourSelectorVisible) {
        event.preventDefault();
        this.minuteSelectorVisible = false;
        this.hourSelectorVisible = false;
      }
    },
    scrollTopMinute: function scrollTopMinute() {
      var mHeight = this.$refs.minuteScroller.scrollHeight;
      var wHeight = this.$refs.minuteScrollerWrapper.clientHeight;
      var top = mHeight * (this.minuteIndex / (this.minutes.length - 1)) - wHeight / 2;
      this.$refs.minuteScroller.scrollTop = top;
    },
    scrollTopHour: function scrollTopHour() {
      var mHeight = this.$refs.hourScroller.scrollHeight;
      var wHeight = this.$refs.hourScrollerWrapper.clientHeight;
      var top = mHeight * (this.hourIndex / (this.hours.length - 1)) - wHeight / 2;
      this.$refs.hourScroller.scrollTop = top;
    },
    changePeriod: function changePeriod() {
      this.period = this.period === AM ? PM : AM;
    },
    calendarClicked: function calendarClicked(event) {
      if (event.target.id !== 'j-hour' && event.target.id !== 'j-minute') {
        this.minuteSelectorVisible = false;
        this.hourSelectorVisible = false;
      }
      event.cancelBubble = true;
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    },
    documentClicked: function documentClicked(event) {
      if (event.target.id !== 'tj-datetime-input') {
        this.hideCal = true;
      }
    },
    toggleCal: function toggleCal() {
      this.hideCal = !this.hideCal;
    },
    setDate: function setDate() {
      var d = null;
      if (this.dateFormat.indexOf('H') !== -1) {
        this.periodStyle = 24;
        this.period = null;
      } else {
        this.periodStyle = 12;
      }
      var h = this.hour + '';

      if (this.periodStyle === 12) {
        if (h === '12') {
          h = this.period === AM ? '00' : '12';
        } else if (this.period === PM && parseInt(h) < 12) {
          h = parseInt(h) + 12;
          h = '' + h;
        } else if (this.period === AM && parseInt(h) > 12) {
          h = parseInt(h) - 12;
          h = '' + h;
        }
      }
      d = this.dateFormat;
      d = d.replace('YYYY', this.year);
      d = d.replace('DD', this.day < 10 ? '0' + this.day : this.day);
      var m = this.monthIndex + 1;
      d = d.replace('MM', m < 10 ? '0' + m : m);
      this.minute += '';
      d = d.replace(this.periodStyle === 24 ? 'H' : 'h', h.length < 2 ? '0' + h : '' + h);
      d = d.replace('i', this.minute.length < 2 ? '0' + this.minute : '' + this.minute);
      d = d.replace('s', '00');
      this.$emit('input', d);
      this.date = d;
      this.hideCal = true;
    },

    /**
    `*Creates a date object from a given date string
    */
    makeDateObject: function makeDateObject(val) {
      // handle support for eu date format
      var dateAndTime = val.split(' ');
      var arr = [];
      if (this.format.indexOf('-') !== -1) {
        arr = dateAndTime[0].split('-');
      } else {
        arr = dateAndTime[0].split('/');
      }
      var year = 0;
      var month = 0;
      var day = 0;
      if (this.format.indexOf('DD/MM/YYYY') === 0 || this.format.indexOf('DD-MM-YYYY') === 0) {
        year = arr[2];
        month = arr[1];
        day = arr[0];
      } else if (this.format.indexOf('YYYY/MM/DD') === 0 || this.format.indexOf('YYYY-MM-DD') === 0) {
        year = arr[0];
        month = arr[1];
        day = arr[2];
      } else {
        year = arr[2];
        month = arr[0];
        day = arr[1];
      }

      var date = new Date();
      if (this.hideDate) {
        // time only
        var splitTime = dateAndTime[0].split(':');
        date.setHours(parseInt(splitTime[0]), parseInt(splitTime[1]), parseInt(splitTime[2]), 0);
      } else if (this.hideTime) {
        // date only
        date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      } else {
        // we have both date and time
        var splitTime = dateAndTime[1].split(':');
        date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(splitTime[0]), parseInt(splitTime[1]), parseInt(splitTime[2]));
      }

      return date;
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.value) {
      try {
        this.timeStamp = this.makeDateObject(this.value);

        // set #period (am or pm) based on date hour
        if (this.timeStamp.getHours() >= 12) {
          this.period = PM;
        } else {
          this.period = AM;
        }
      } catch (e) {
        this.timeStamp = new Date();
        console.log(e);
      }
    }

    this.year = this.timeStamp.getFullYear();
    this.monthIndex = this.timeStamp.getMonth();
    this.day = this.timeStamp.getDate();
    this.hour = this.timeStamp.getHours();
    this.hour = this.hour < 10 ? '0' + this.hour : '' + this.hour;
    this.minute = this.timeStamp.getMinutes();
    this.minute = this.minute < 10 ? '0' + this.minute : '' + this.minute;
    this.updateCalendar();
    days.forEach(function (day, idx) {
      _this2.days[(idx - _this2.normalizedFirstDayOfWeek + 7) % 7] = day;
    });
    document.addEventListener('keydown', this.keyIsDown);
    document.addEventListener('click', this.documentClicked);
    this.setDate();
  },

  watch: {
    value: function value(newVal, oldVal) {
      if (newVal) {
        this.value = newVal;
        try {
          this.timeStamp = this.makeDateObject(this.value);
          var old = this.makeDateObject(oldVal);
          if (oldVal === this.timeStamp) {
            return;
          }
        } catch (e) {
          console.warn(e.message + '. Current date is being used.');
          this.timeStamp = new Date();
        }
      }
      this.year = this.timeStamp.getFullYear();
      this.monthIndex = this.timeStamp.getMonth();
      this.day = this.timeStamp.getDate();
      this.hour = this.timeStamp.getHours();
      this.hour = this.hour < 10 ? '0' + this.hour : '' + this.hour;
      this.minute = this.timeStamp.getMinutes();
      this.minute = this.minute < 10 ? '0' + this.minute : '' + this.minute;
      this.updateCalendar();
      this.setDate();
    }
  },
  destroyed: function destroyed() {
    document.removeEventListener('keydown', this.keyIsDown);
    document.removeEventListener('click', this.documentClicked);
  },
  computed: {
    normalizedFirstDayOfWeek: function normalizedFirstDayOfWeek() {
      return parseInt(this.firstDayOfWeek, 10);
    },
    ports: {
      get: function get() {
        var p = [];
        if (this.portsHolder.length === 0) {
          for (var i = 0; i < 42; i++) {
            p.push('');
          }
        } else {
          p = this.portsHolder;
        }
        return p;
      },
      set: function set(newValue) {
        this.portsHolder = newValue;
      }
    },
    month: function month() {
      return this.months[this.monthIndex];
    },
    dateTime: function dateTime() {
      return this.timeStamp.getFullYear() + '-' + (this.timeStamp.getMonth() + 1) + '-' + this.timeStamp.getUTCDay();
    },
    minutes: function minutes() {
      var arr = [];
      for (var i = 0; i < 60; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i);
      }
      return arr;
    },
    hours: function hours() {
      var arr = [];
      if (this.periodStyle === 24) {
        for (var i = 0; i < this.periodStyle; i++) {
          i < 10 ? arr.push('0' + i) : arr.push('' + i);
        }
      } else {
        for (var _i = 1; _i <= this.periodStyle; _i++) {
          _i < 10 ? arr.push('0' + _i) : arr.push('' + _i);
        }
      }
      return arr;
    },
    dateFormat: function dateFormat() {
      var f = 'YYYY-MM-DD h:i:s';
      var allowedFormats = ['YYYY-MM-DD h:i:s', 'DD-MM-YYYY h:i:s', 'MM-DD-YYYY h:i:s', 'YYYY-MM-DD H:i:s', 'DD-MM-YYYY H:i:s', 'MM-DD-YYYY H:i:s', 'YYYY-MM-DD', 'DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY/MM/DD', 'DD/MM/YYYY', 'MM/DD/YYYY', 'h:i:s', 'H:i:s', 'YYYY/MM/DD h:i:s', 'DD/MM/YYYY h:i:s', 'MM/DD/YYYY h:i:s', 'YYYY/MM/DD H:i:s', 'DD/MM/YYYY H:i:s', 'MM/DD/YYYY H:i:s'];
      if (this.format) {
        f = this.format;
      }
      if (allowedFormats.indexOf(f) < 0) {
        console.warn('Invalid date format supplied. Current default date format is being used.');
        // return default date format if date format is invalid
        return 'YYYY-MM-DD h:i:s';
      } else {
        return f;
      }
    },
    hideTime: function hideTime() {
      return this.dateFormat.indexOf('h:i:s') === -1 && this.dateFormat.indexOf('H:i:s') === -1;
    },
    hideDate: function hideDate() {
      return this.dateFormat === 'h:i:s' || this.dateFormat === 'H:i:s';
    }
  }
};

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datetime-picker",
    style: ({
      width: _vm.width
    }),
    on: {
      "click": function($event) {
        _vm.calendarClicked($event)
      }
    }
  }, [_c('div', [_c('input', {
    attrs: {
      "type": "text",
      "id": "tj-datetime-input",
      "name": _vm.name,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.date
    },
    on: {
      "click": _vm.toggleCal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calender-div",
    class: {
      noDisplay: _vm.hideCal
    }
  }, [_c('div', {
    class: {
      noDisplay: _vm.hideDate
    }
  }, [_c('div', {
    staticClass: "year-month-wrapper"
  }, [_c('div', {
    staticClass: "month-setter"
  }, [_c('button', {
    staticClass: "nav-l",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.leftYear
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "year"
  }, [_vm._v(_vm._s(_vm.year))]), _vm._v(" "), _c('button', {
    staticClass: "nav-r",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rightYear
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('div', {
    staticClass: "month-setter"
  }, [_c('button', {
    staticClass: "nav-l",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.leftMonth
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "month"
  }, [_vm._v(_vm._s(_vm.month))]), _vm._v(" "), _c('button', {
    staticClass: "nav-r",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rightMonth,
      "mousedown": function($event) {}
    }
  }, [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "headers"
  }, _vm._l((_vm.days), function(port) {
    return _c('span', {
      staticClass: "days"
    }, [_vm._v(_vm._s(port))])
  })), _vm._v(" "), _c('div', _vm._l((_vm.weeks), function(week, weekIndex) {
    return _c('div', {
      staticClass: "week"
    }, _vm._l((week), function(day, dayIndex) {
      return _c('span', {
        staticClass: "port",
        class: {
          activePort: (weekIndex * 7 + dayIndex) === _vm.activePort
        },
        on: {
          "click": function($event) {
            _vm.setDay(weekIndex * 7 + dayIndex, day)
          }
        }
      }, [_vm._v("\n              " + _vm._s(day) + "\n            ")])
    }))
  }))]), _vm._v(" "), _c('div', {
    staticClass: "time-picker",
    class: {
      noDisplay: _vm.hideTime
    }
  }, [_c('div', {
    staticClass: "hour-selector"
  }, [_c('div', {
    attrs: {
      "id": "j-hour"
    },
    on: {
      "click": _vm.showHourSelector
    }
  }, [_vm._v(_vm._s(_vm.periodStyle === 12 && _vm.hour > 12 ? _vm.hour - 12 : _vm.hour))]), _vm._v(" "), _c('div', {
    ref: "hourScrollerWrapper",
    staticClass: "scroll-hider",
    class: {
      showSelector: _vm.hourSelectorVisible
    }
  }, [_c('ul', {
    ref: "hourScroller"
  }, _vm._l((_vm.hours), function(h, index) {
    return _c('li', {
      class: {
        active: index == _vm.hourIndex
      },
      on: {
        "click": function($event) {
          _vm.setHour(index, true)
        }
      }
    }, [_vm._v(_vm._s(h))])
  }))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "minute-selector"
  }, [_c('div', {
    attrs: {
      "id": "j-minute"
    },
    on: {
      "click": _vm.showMinuteSelector
    }
  }, [_vm._v(_vm._s(_vm.minute))]), _vm._v(" "), _c('div', {
    ref: "minuteScrollerWrapper",
    staticClass: "scroll-hider",
    class: {
      showSelector: _vm.minuteSelectorVisible
    }
  }, [_c('ul', {
    ref: "minuteScroller"
  }, _vm._l((_vm.minutes), function(m, index) {
    return _c('li', {
      class: {
        active: index == _vm.minuteIndex
      },
      on: {
        "click": function($event) {
          _vm.setMinute(index, true)
        }
      }
    }, [_vm._v(_vm._s(m))])
  }))])]), _vm._v(" "), (_vm.periodStyle === 12) ? _c('div', {
    staticClass: "time-separator"
  }, [_c('span', [_vm._v(":")])]) : _vm._e(), _vm._v(" "), (_vm.periodStyle === 12) ? _c('div', {
    staticClass: "minute-selector"
  }, [_c('div', {
    on: {
      "click": _vm.changePeriod
    }
  }, [_vm._v(_vm._s(_vm.period))])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "okButton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setDate
    }
  }, [_vm._v("OK")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-separator"
  }, [_c('span', [_vm._v(":")])])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_vm._l((_vm.items), function(item, key) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(" " + _vm._s(item.label) + " ")])]), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "YYYY-MM-DD H:i:s",
        "disabled": item.disabled
      },
      on: {
        "input": _vm.updateDate
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((item.errors), function(error) {
      return (item.type === 'date') ? _c('div', {
        staticStyle: {
          "margin-left": "18px"
        },
        attrs: {
          "id": "errors"
        },
        model: {
          value: (item.errors),
          callback: function($$v) {
            _vm.$set(item, "errors", $$v)
          },
          expression: "item.errors"
        }
      }, [_c('div', {
        staticClass: "clearfix"
      }), _vm._v("\n                " + _vm._s(error) + "\n                "), _vm._m(1, true)]) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Exportar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.exportpqr
    }
  })])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Exporte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('br')])
}]}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emt_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_emt_grid__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-gender',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre',
                'placeholder': 'Ingrese nombre de género',
                'value': null,
                'maxlength': '20',
                'type': 'text',
                'errors': []
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }],
            itemsGrid: [{
                'name': 'name',
                'label': 'Nombre',
                'ordering': true,
                'filters': ['exact', {
                    'name': 'icontains',
                    'label': 'Puede contener'
                }]
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': null,
                'ordering': true
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: false,
            editUrl: '/Genero/',
            deleteUrl: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/Genero/'
        };
    },
    methods: {
        reload: function reload() {
            this.$refs['gender-grid'].reload();
        }
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a,
        'emt-loading': __WEBPACK_IMPORTED_MODULE_5__components_emt_loading___default.a,
        'emt-grid': __WEBPACK_IMPORTED_MODULE_6__components_emt_grid___default.a
    }
});

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "area-form",
    attrs: {
      "resource": _vm.config.api + '/gender/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "gender-grid",
    attrs: {
      "resource": _vm.config.api + '/gender/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Géneros")])])
}]}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emt_form__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emt-form-edit-gender',
    data: function data() {
        return {
            itemsForm: [{
                'name': 'name',
                'label': 'Nombre',
                'placeholder': 'Ingrese nombre de género',
                'value': null,
                'maxlength': '20',
                'type': 'text',
                'errors': []
            }, {
                'name': 'is_active',
                'label': 'Estado',
                'value': false,
                'type': 'checkbox',
                'errors': []
            }],
            config: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */],
            update: true
        };
    },
    created: function created() {
        if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token')) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2__generic__["a" /* default */].setToken();
        this.getData(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api + '/gender/');
    },
    methods: {
        getData: function getData(url) {
            url = '' + url + this.$route.params.id + '/';
            var self = this;
            self.$http.get(url).then(function (response) {
                self.setValue(response.body);
            }, function (response) {});
        },
        setValue: function setValue(value) {
            for (var form in this.itemsForm) {
                this.itemsForm[form].value = value[this.itemsForm[form].name];
            }
        }
    },
    components: {
        'emt-form': __WEBPACK_IMPORTED_MODULE_4__components_emt_form___default.a
    }
});

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "unit-form",
    attrs: {
      "resource": _vm.config.api + '/gender/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar Género")])])
}]}

/***/ })
],[62]);


// WEBPACK FOOTER //
// static/js/app.3c53147478215ef34aca.js